import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { Card, CardActions, CardContent, Divider, Button, Box, Grid, TextField, Checkbox, FormGroup, FormControlLabel, TextareaAutosize, InputLabel,NativeSelect,FormHelperText,Container, FormControl, Select, MenuItem, Chip } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import clsx from 'clsx';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { QRCodeCanvas } from 'qrcode.react';

import axios from 'axios';
import { authMiddleWare } from '../util/auth';

import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

/*import firebase from 'firebase/app'
import 'firebase/storage'
import 'firebase/analytics'*/

import firebase from '../util/firebase';
import urlExists from 'url-exists-nodejs'

import SceneEditor from "../components/sceneEditor";

 
import '../styles/styles' 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEdit, faTrash, faPlusSquare, faGlobe, faAlignLeft, faImage, faVideo, faVolumeUp, faFile } from '@fortawesome/free-solid-svg-icons'
import {createTheme,ThemeProvider} from "@material-ui/core/styles"

const theme = createTheme({
 breakpoints: {
   values: {
    xs: 0,
    sm: 450,
    md: 600,
    lg: 900,
    xl: 1200,
    tablet:1024
  }
}
});





/*
var firebaseConfig = {
    apiKey: "AIzaSyA3eaJyPsSgP4w44xec072whAo3ylvlHkY",
    authDomain: "moval-4c0b4.firebaseapp.com",
    projectId: "moval-4c0b4",
    storageBucket: "moval-4c0b4.appspot.com",
    messagingSenderId: "852374290766",
    appId: "1:852374290766:web:0996678ff44c53119fde1f"
  };

firebase.initializeApp(firebaseConfig);
*/

	
const styles = (theme) => ({
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
		flex:6,
		width:'100%',
	},
	block:{
	width:'100%', flex:1,},
	toolbar: theme.mixins.toolbar,
	root: {},
	details: {
		display: 'flex'
	},
	formcontent:{
		paddingLeft: '15px',
		paddingRight: '15px',

	},
	avatar: {
		height: 110,
		width: 100,
		flexShrink: 0,
		flexGrow: 0
	},
	locationText: {
		paddingLeft: '15px'
	},
	buttonProperty: {
		position: 'absolute',
		top: '50%'
	},
	uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	},
	progess: {
		position: 'absolute'
	},
	uploadButton: {
		marginLeft: '8px',
		margin: theme.spacing(1)
	},
	customError: {
		color: 'red',
		fontSize: '0.8rem',
		marginTop: 10
	},
	submitButton: {
		marginTop: '10px'
	},
		firstLine: {
		marginTop: '100px',
		paddingLeft: '15px',
		paddingRight: '15px',	
	},
	
	markerType:{
	marginTop: '20px',
	marginBottom: '20px',
	},
	markerIdBlock:{
	width:'100%'	
	}
	
});


const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});	

const umlautMap = {
		  '\u00dc': 'UE',
		  '\u00c4': 'AE',
		  '\u00d6': 'OE',
		  '\u00fc': 'ue',
		  '\u00e4': 'ae',
		  '\u00f6': 'oe',
		  '\u00df': 'ss',
}


//project Download file PDF etc next  

class newProject extends Component {
	constructor(props) {
		super(props);
		
		
		this.state = {
			forcedReload: [],
			viewMode:'',
			viewModeMarker:'',
			firstName: '',
			lastName: '',
			email: '',
			phoneNumber: '',
			username: '',
			country: '',
			profilePicture: '',
			uiLoading: true,
			buttonLoading: false,
			imageError: '',
			markerWindowOpen: false,
			projectId:'',
			projectSubline:'',
			projectDescription:'',
			projectCode:'',
			projectTitle:'',
			projectActive:true,
			projectExclusive:false,
			projectHideMarkerlist:false,
			projectDataLink:'',
			projectPrivate:false,
			projectColor:'',
			projectType:0,
            availableCategories: [],   // alle Kategorien aus der Collection "categories"
            projectCategories: [],  
			projectimage:'',
			projectlogoimage:'',
			currentprojectimage:'',
			currentprojectlogoimage:'',
			imageDB:'',
			visualMarker:[],
			visualMarkerAdded:[],
			geoMarker:[],
			geoMarkerAdded:[],
			errors: [],
			tempMarkerImage:'',
			markerImage:'',
			markerImageUrls:[],
			galleryView:false,
			pdfView:false,
			markerId:'',
			markerTitle:'',
			markerDescription:'',
			markerType:'',
			markerStyle:'icon',
			markerColor:'',
			overlayStyle:'sheet',
			markerURL:'',
			markerURLInline:true,
			markerDirectOpen:false,
			markerText:'',
			externalImageURL:'',
			externalImageURLLinks:'',
			videoURL:'',
			audioURL:'',
			fileURL:'',
			fileURLdescription:'',
			markerAR:'',
            markerARtemp: {
                arSceneDescription: "",
                active: true,
                arNodes: []
              },
			showMarkerColor:true,
			showMarkerDirectOpen:false,
			showMarkerURL:false,
			showMarkerURLinline:false,
			showTextMarker:false,
			showExternalImageURL:false,
			showVideoURL:false,
			showAudioURL:false,
			showFileURL:false,
			showARMarker:false,
			showMarkerTitleHelper:false,
			showMarkerWidthHelper:false,
			showMarkerHeightHelper:false,
			showMarkerImageHelper:false,
			showMarkerTypeHelper:false,
			showGeoLongitudeHelper:false,
			showGeoLatitudeHelper:false,
			markerWidth:'0',
			markerHeight:'0',
			geoPoint:{_latitude:0.0, _longitude:0.0},
			markerContent:'',
			markerSrc:null,
			markerHidden:false,
			oldMarkerImage:'',
			projectImageRdy:0,
			projectLogoImageRdy:0,
			crop: {
			  unit: '%',
			  aspect: 4 / 3,
			},
			
		};
		
    		this.handleDeleteMarker = this.handleDeleteMarker.bind(this);

			this.handleAddMarkerOpenWindow= this.handleAddMarkerOpenWindow.bind(this);
			this.handleEditMarkerOpenWindow= this.handleEditMarkerOpenWindow.bind(this);

		
	}
	
	  handleDeleteMarker(val) {}
	
	handleEditMarkerOpenWindow(marker){}

	componentWillMount = () => {};







componentDidMount = () => {
	
	
	//const history = useHistory();
	console.log("HISTORRRRRY")
	//console.log(history)

	
	authMiddleWare(this.props.history);
		const authToken = localStorage.getItem('AuthToken');
		axios.defaults.headers.common = { Authorization: `${authToken}` };
    
    
		axios
			.get('/user')
			.then((response) => {
				this.setState({
					firstName: response.data.userCredentials.firstName,
					lastName: response.data.userCredentials.lastName,
					email: response.data.userCredentials.email,
					phoneNumber: response.data.userCredentials.phoneNumber,
					country: response.data.userCredentials.country,
					username: response.data.userCredentials.username,
					uiLoading: false
				});
			})
			.catch((error) => {
				if (error.response.status === 403) {
					this.props.history.push('/login');
				}
				this.setState({ errorMsg: 'Error in retrieving the data' });
			});
	
	
           axios
            .get('/categories')  // laut index.js ohne Auth, Header schaden aber nicht
            .then((res) => {
              // Erwartung: Array von Dokumenten wie:
              // { id: "816", categoryTitle: "...", categoryIcon: "..." }
              this.setState({ availableCategories: res.data || [] });
            })
            .catch((err) => {
              console.log('Fehler beim Laden der Kategorien', err);
            });
	

		var viewMode ="viewProject"
		
		viewMode = this.props.viewMode

		if(this.props.viewMode){
			
			// Edit view of project
			
			if (this.props.viewMode =="editProject"){

				
				var projectActive = true
				if(this.props.project.projectActive == undefined){
					projectActive = true
				}
				else{
					projectActive = this.props.project.projectActive
				}
				
				var projectPrivate = true
				if(this.props.project.projectPrivate == undefined){
					projectPrivate = true
				}
				else{
					projectPrivate = this.props.project.projectPrivate
				}
				
				var projectExclusive = false
				
				if(this.props.project.projectExclusive == undefined){
					projectExclusive = false
				}
				else{
					projectExclusive = this.props.project.projectExclusive
				}
				
				var projectHideMarkerlist = false
				
				if(this.props.project.projectHideMarkerlist == undefined){
					projectHideMarkerlist = false
				}
				else{
					projectHideMarkerlist = this.props.project.projectHideMarkerlist
				}
				
					// set state vars of passed project
					this.setState({
						viewMode: viewMode,
						projectId: this.props.project.projectId,
						projectSubline:this.props.project.projectSubline,
						projectDescription:this.props.project.projectDescription,
						projectCode:this.props.project.projectCode,
						projectTitle:this.props.project.projectTitle,
						projectActive: projectActive,
						projectPrivate: projectPrivate,
						projectExclusive: projectExclusive,
						projectHideMarkerlist: projectHideMarkerlist,
						projectColor:this.props.project.projectColor,
						projectType:this.props.project.projectType,
						projectDataLink:this.props.project.projectDataLink,
						currentprojectimage:this.props.project.projectImage,
						currentprojectlogoimage: this.props.project.projectLogoImage,
                        projectCategories: this.props.project.categories || []
					});


				// get all Markers from DB	
				// markerImage = URL String	
				// => existing markers = URL String ... new added markers = blob 

				//Get all markers with passed project/projectId
				const authToken = localStorage.getItem('AuthToken');
				axios.defaults.headers.common = { Authorization: `${authToken}` };
				
				
				
				
				axios
				.get(`/project/${this.props.project.projectId}`)
				.then((response) => {

					var helperArray= [];

					
						this.setState({
						visualMarker: response.data[0].visualMarker,
						});
					
						this.setState({
						geoMarker: response.data[0].geoMarker,
						});


						// safe markers responsein visualDate
						/*this.setState({
						visualMarker: response.data,
						});*/


				})
				.catch((err) => {
					console.log("no results");
					console.log(err);
				});
				
				/*
				axios
				.get(`/marker/${this.props.project.projectId}`)
				.then((response) => {

					var helperArray= [];

					 response.data.forEach((vmarker) => {

										var projectName = this.state.projectId;

										var storageRef = firebase.storage().ref();
										var downloadRef =  storageRef.child("images/"+projectName+"/"+vmarker.markerImage);
										vmarker.markerImage =  "https://firebasestorage.googleapis.com/v0/b/moval-4c0b4.appspot.com/o/images%2F"+projectName+"%2F"+vmarker.markerImage+"?alt=media";

						})

						console.log("DIE RESPONSE MARKER"+response.data)

						// safe markers responsein visualDate
						this.setState({
						visualMarker: response.data,
						});


				})
				.catch((err) => {
				console.log("KEINE RESULTATE im Marker");
					console.log(err);
				});
				*/
				
				
				/*axios.defaults.headers.common = { Authorization: `${authToken}` };
				
				axios
				.get(`/project/getimagedbfile/${this.props.project.projectId}`)
				.then((response) => {

						console.log("DER RESPONSE DES GETIMAGEDB PROJECTS")
					    console.log(response.data)
					

				})
				.catch((err) => {
				console.log("KEINE RESULTATE im Marker");
					console.log(err);
				});*/
				
				
				//this.checkImageDBExists()
					
				
			}
			
			
			
			
			// Ansicht neues Project
			if (this.props.viewMode =="newProject"){
					console.log("NEUES PROJECT");
				
				this.setState({
					viewMode: viewMode,
					projectId: '',
					projectSubline:'',
					projectDescription:'',
					projectCode:'',
					projectTitle:'',
					projectActive:true,
					projectPrivate:false,
					projectColor:'',
					projectDataLink:'',
                    projectType: 0,
                    // NEU:
                    projectCategories: []
				});
			}
			
			
			// Ansicht delete Project
			if (this.props.viewMode =="deleteProject"){
				console.log("Delete PROJECT");
				
				this.setState({
					viewMode: viewMode,
					projectId: this.props.project.projectId,
					projectSubline:this.props.project.projectSubline,
					projectDescription:this.props.project.projectDescription,
					projectCode:this.props.project.projectCode,
					projectTitle:this.props.project.projectTitle,
					projectActive:this.props.project.projectActive,
					projectPrivate:this.props.project.projectPrivate,
					projectExclusive:this.props.project.projectExclusive,
					projectHideMarkerlist:this.props.project.projectHideMarkerlist,
					projectColor:this.props.project.projectColor,
					projectType:this.props.project.projectType,
					projectDataLink:this.props.project.projectDataLink
				});
				
				
				
				authMiddleWare(this.props.history);
				const userPoject = {
					projectSubline: this.state.projectSubline,
					projectDescription: this.state.projectDescription,
					projectCode: this.state.projectCode,
					projectTitle: this.state.projectTitle,
					projectActive: this.state.projectActive,
					projectPrivate: this.state.projectPrivate,
					projectExclusive: this.state.projectExclusive,
					projectHideMarkerlist:this.state.projectHideMarkerlist,
					projectColor: this.state.projectColor,
					projectType:this.state.projectType,
					projectDataLink: this.state.projectDataLink
				};
				let options = {};

				options = {
								url: `/project/${this.props.project.projectId}`,
								method: 'delete',
								data: userPoject
				};


				const authToken = localStorage.getItem('AuthToken');
					axios.defaults.headers.common = { Authorization: `${authToken}` };
					axios(options)
						.then(() => {
							this.setState({ open: false });
							window.location.reload();
						})
						.catch((error) => {
							this.setState({ open: true, errors: error.response.data });
							console.log(error);
						});

			}

		} //end if viewmode setted
		
	
		else{
			
			viewMode = "newProject"
			
			this.setState({
					viewMode: viewMode,
					projectId: '',
					projectSubline:'',
					projectDescription:'',
					projectCode:'',
					projectTitle:'',
					projectActive:true,
				    projectExclusive:false,
				    projectHideMarkerlist:false,
			    	projectPrivate:false,
					projectColor:'',
					projectType:0,
				   projectDataLink:'',
                    // NEU:
                    projectCategories: []
				});
			
		}
		
		
	
} // End component did mount






	handleChange = (event) => {

		this.setState({
			[event.target.name]: event.target.value
		});
		
		console.log("######")
		console.log(event.target.name)
		console.log(this.state.projectActive)

		if(event.target.name == "projectActive"){
		   
				if((this.state.projectActive == false) || (this.state.projectActive == undefined)){
						this.setState({projectActive: true})
				}
				else{
						this.setState({projectActive: false})
				}
		   }
		
		
		if(event.target.name == "projectPrivate"){
		   
				if((this.state.projectPrivate == false) || (this.state.projectPrivate == undefined)){
						this.setState({projectPrivate: true})
				}
				else{
						this.setState({projectPrivate: false})
				}
		   }
		
		if(event.target.name == "projectExclusive"){
		   
				if((this.state.projectExclusive == false) || (this.state.projectExclusive == undefined)){
						this.setState({projectExclusive: true})
				}
				else{
						this.setState({projectExclusive: false})
				}
		   }
		
		if(event.target.name == "projectHideMarkerlist"){
		   
				if((this.state.projectHideMarkerlist == false) || (this.state.projectHideMarkerlist == undefined)){
						this.setState({projectHideMarkerlist: true})
				}
				else{
						this.setState({projectHideMarkerlist: false})
				}
		   }
		
		
		
		
		
		
	};


	handleProjectTypeChange = (event) => {
		if(event.target.name == "projectType"){
				this.setState({projectType: event.target.value})
			
		}

	};

    handleCategoryChange = (event) => {
  console.log('category change:', event.target.value);
  const { value } = event.target;
  this.setState({
    projectCategories: Array.isArray(value)
      ? value
      : typeof value === 'string'
      ? value.split(',')
      : []
  });
};



	// event ausgelöst durch Änderung der Eingabefelder im Marker-Form
	handleMarkerChange = (event) => {
		
		console.log("CLICK")
		console.log(event.target.name)
		console.log(this.state.markerURLInline)
		
		

		// Marker Type wurde geändert => show related input field
		if(event.target.name == "markerType"){
			
				
			   if(event.target.value == "1"){
				   	this.setState({showMarkerURL: true,	
								   showMarkerURLinline:true,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:false,
								  })
			   }
			
			if(event.target.value == "2"){
				
				   		this.setState({showMarkerURL: false,
									showMarkerURLinline:false,
									showTextMarker:true,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:false,
								  })


			   }
			
			if(event.target.value == "3"){
				   	   		this.setState({showMarkerURL: false,				      
									showTextMarker:false,
									showExternalImageURL:true,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:false,
								  })

			   }
			
			   if(event.target.value == "4"){
				   	this.setState({showMarkerURL: false,
								   	showMarkerURLinline:false,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:true,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:false,
								  })

			   }
			
			if(event.target.value == "5"){
				      	this.setState({showMarkerURL: false,
									showMarkerURLinline:false,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:true,
									showFileURL:false,
									showARMarker:false,
									   
								  })

			   }
			
			if(event.target.value == "6"){
				   	this.setState({showMarkerURL: false,
									showMarkerURLinline:false,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:true,
									showARMarker:false,
								  })

			   }
		   	 if(event.target.value == "7"){
				   		this.setState({showMarkerURL: false,
									showMarkerURLinline:false,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:true,
									   
								  })

			   }
			
			
			
		   }
		
		
	
	
		this.setState({
			[event.target.name]: event.target.value
		});
		
		
		if((event.target.name == "markerWidth") && (this.state.markerHeight != 0)) {
			
			var markerProportion = event.target.value / this.state.markerHeight
			
		}
		
		if((event.target.name == "markerHeight") && (this.state.markerHeight != 0)) {
			
			var markerProportion = this.state.markerWidth / event.target.value
			
		}
		
		//toggle checkbox
		if(event.target.name == "markerURLInline"){
				console.log(this.state.markerURLInline)
				if(this.state.markerURLInline == false){
						this.setState({markerURLInline: true})
				}
				else{
						this.setState({markerURLInline: false})

				}
			}
		// toggelcheckbox
		if(event.target.name == "markerDirectOpen"){
				console.log(this.state.markerDirectOpen)
				if(this.state.markerDirectOpen == false){
						this.setState({markerDirectOpen: true})
				}
				else{
						this.setState({markerDirectOpen: false})

				}
			}
		
		if(event.target.name == "markerHidden"){
				console.log(this.state.markerHidden)
				if(this.state.markerHidden == false){
						this.setState({markerHidden: true})
				}
				else{
						this.setState({markerHidden: false})

				}
			}
		
		
		if(event.target.name == "galleryView"){
				console.log(this.state.galleryView)
				if(this.state.galleryView == false){
						this.setState({galleryView: true})
				}
				else{
						this.setState({galleryView: false})

				}
			}
		
			if(event.target.name == "pdfView"){
				console.log(this.state.pdfView)
				if(this.state.pdfView == false){
						this.setState({pdfView: true})
				}
				else{
						this.setState({pdfView: false})

				}
			}
		
			
		
		
		if(event.target.name == "markerStyle"){
			
			if(event.target.value == "frame"){
					this.setState({showMarkerColor: false, showMarkerDirectOpen: true})
				

			}
			else{
				this.setState({showMarkerColor: true, showMarkerDirectOpen:false})
				
				

			}
			
		}
		
		if(event.target.name == "_latitude"){

					let tempGeopoint = {_latitude:event.target.value,
				   _longitude:this.state.geoPoint._longitude
					}
					
					this.state.geoPoint = tempGeopoint

		}
		
		if(event.target.name == "_longitude"){
						let tempGeopoint = {_latitude:this.state.geoPoint._latitude,
				   _longitude:event.target.value
					}
						
					this.state.geoPoint = tempGeopoint
		}
		
		
		// set image crop proportions
		this.setState({crop: {aspect:markerProportion}})
		
				

	};

		// event ausgelöst von project image selection
	handleImageChange = (event) => {
		
		console.log("FILE SIZE")
		console.log(event.target.files[0].size)
		if(event.target.files[0].size / 1000000 > 1){
			alert("FILESIZE ZU GROSS")
			
			event.target.value = null;
		}
		else{
			this.setState({
			projectimage: event.target.files[0], projectImageRdy: 1
			});
		}
		// set projectimage with local selected image
		
	};


	handleLogoImageChange = (event) => {
		
		console.log("FILE SIZE")
		console.log(event.target.files[0].size)
		if(event.target.files[0].size / 1000000 > 1){
			alert("FILESIZE ZU GROSS")
			
			event.target.value = null;
		}
		else{
			this.setState({
			projectlogoimage: event.target.files[0], projectLogoImageRdy: 1
			});
		}
		// set projectimage with local selected image
		
	};


		// event ausgelöst von project image upload button

	projectPictureHandler = (event) => {
		
		if((this.state.projectImageRdy == 1) && (this.state.projectimage["type"] != "")) {
		
		var projectFileType="";
		
		if(this.state.projectimage["type"] == "image/jpeg"){
			
			projectFileType = "jpeg"
		}
		
		if(this.state.projectimage["type"] == "image/png"){
			
			projectFileType = "png"
		}
		

		event.preventDefault();
		this.setState({
			uiLoading: true
		});
			
		authMiddleWare(this.props.history);
		const authToken = localStorage.getItem('AuthToken');
		
		
		// upload project image with filename = projectId
		var uploadPath = "images/"+this.state.projectId+"/"+this.state.projectId+"."+projectFileType;
		var storageRef = firebase.storage().ref();
		var uploadRef = storageRef.child(`${uploadPath}`);
					
		uploadRef.put(this.state.projectimage).then((snapshot) => {
			
			
			const editedProjectImage = {
				projectImage: this.state.projectId+"."+projectFileType,
			};
			
			console.log("VOR DB CHANGE")
			console.log(this.state.projectId+"."+projectFileType)

			// perform firebase db change

			var optionsImageUpdate = {
							url: `/project/imageupdate/${this.state.projectId}`,
							method: 'put',
							data: editedProjectImage
						};
			
			
			
				const authToken = localStorage.getItem('AuthToken');
				axios.defaults.headers.common = { Authorization: `${authToken}` };
				axios(optionsImageUpdate)
					.then((response) => {
						
						// db change successful
					    //window.location.reload();
						this.setState({ open: false, projectImageRdy:0, uiLoading:false});
				
				
				})
					.catch((error) => {
						this.setState({ open: true, projectImageRdy:0, errors: error.response.data, currentprojectimage: editedProjectImage.projectImage  });
						console.log(error);
					});
			
					
				}).catch((error) => {
								console.log("FEHLER"+error);
							});
		
		
		
	}	
		
	};








projectLogoPictureHandler = (event) => {
		
		if((this.state.projectLogoImageRdy == 1) && (this.state.projectlogoimage["type"] != "")) {
		
		var projectLogoFileType="";
		
		if(this.state.projectlogoimage["type"] == "image/jpeg"){
			
			projectLogoFileType = "jpeg"
		}
		
		if(this.state.projectlogoimage["type"] == "image/png"){
			
			projectLogoFileType = "png"
		}
		

		event.preventDefault();
		this.setState({
			uiLoading: true
		});
			
		authMiddleWare(this.props.history);
		const authToken = localStorage.getItem('AuthToken');
		
		
		// upload project image with filename = projectId
		var uploadPath = "images/"+this.state.projectId+"/"+this.state.projectId+"_logo."+projectLogoFileType;
		var storageRef = firebase.storage().ref();
		var uploadRef = storageRef.child(`${uploadPath}`);
					
		uploadRef.put(this.state.projectlogoimage).then((snapshot) => {
			
			
			const editedProjectLogoImage = {
				projectLogoImage: this.state.projectId+"_logo."+projectLogoFileType,
			};
			
			console.log("VOR DB CHANGE Logo")
			console.log(this.state.projectId+"."+projectLogoFileType)

			// perform firebase db change

			var optionsLogoImageUpdate = {
							url: `/project/imageupdate/${this.state.projectId}`,
							method: 'put',
							data: editedProjectLogoImage
						};
			
			
			
				const authToken = localStorage.getItem('AuthToken');
				axios.defaults.headers.common = { Authorization: `${authToken}` };
				axios(optionsLogoImageUpdate)
					.then((response) => {
					
					console.log("IN DB UPDATE NEW LOGO")
					console.log(editedProjectLogoImage)
						
						// db change successful
					    //window.location.reload();
						this.setState({ open: false, projectLogoImageRdy:0, uiLoading:false, currentprojectlogoimage: editedProjectLogoImage.projectLogoImage });
				
				
				})
					.catch((error) => {
						this.setState({ open: true, projectLogoImageRdy:0, errors: error.response.data });
						console.log(error);
					});
			
					
				}).catch((error) => {
								console.log("FEHLER"+error);
							});
		
		
		
	}	
		
	};


	handleAddMarkerOpenWindow() {
		console.log("ADD MARKER")
		authMiddleWare(this.props.history);
		

		// open marker window, set view;odeMarker to addMarker
		this.setState({
			title: "Add visual Marker",
			buttonType: 'Add',
			markerWindowOpen: true,
			viewModeMarker: 'addMarker'
		});
		
		
	}


	handleAddGeoMarkerOpenWindow() {
		authMiddleWare(this.props.history);

		// open marker window, set view;odeMarker to addMarker
		this.setState({
			title: "Add Geo Marker",
			buttonType: 'Add',
			markerWindowOpen: true,
			viewModeMarker: 'addGeoMarker'
		});
	}


// convert to blob
 b64toBlob(dataURI) {
    
    var byteString = atob(dataURI.split(',')[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/jpeg' });
}




	handleOnSelectFile(readerResult){
		
		console.log("readerResult")
		
		
		
		
		//CONVERT LOCAL SELECTED MARKER IMAGE TO BLOB
		var markerImage = this.b64toBlob(readerResult)
		// SET TEMPORARY MARKER IMAGE NAME
		markerImage.fileName =	'newMarkerFile.jpeg'
		console.log(markerImage)
		
		//markerSrc, set when file selected
		this.setState({ markerSrc: readerResult })
		
		
		this.setState({
			markerImage
		});
	
		this.setState({
			tempMarkerImage: markerImage
		});
		
		
		this.checkImageQuality(markerImage);
		
	
	}



	// on select event marker image
	  onSelectFile = (e) => {
		  
		  alert(e.target.files[0].size / 1000000);
		  
		if(e.target.files[0].size / 1000000 > 10){
			alert("FILESIZE ZU GROSS (1000 KB)")
			
			e.target.value = null;
		}
		else{
			
			
			if (e.target.files && e.target.files.length > 0) {
		  const reader = new FileReader();
			

		  reader.addEventListener('load', () =>
			//this.setState({ markerSrc: reader.result })
								  
			// READ LOCAL SELECTED MARKER IMAGE					  
			this.handleOnSelectFile(reader.result)
								  
		  );
			
		  reader.readAsDataURL(e.target.files[0]);
		}
			
			
			
		}
		  
		  
		  
		
	  };

		onImageLoaded = image => {
			this.imageRef = image;
		

		  };

		  onCropComplete = crop => {
			this.makeClientCrop(crop);
		  };

		  onCropChange = (crop, percentCrop) => {
			// You could also use percentCrop:
			// this.setState({ crop: percentCrop });
			this.setState({ crop });
		  };

		
		  async makeClientCrop(crop) {
			if (this.imageRef && crop.width && crop.height) {
			  const markerImage = await this.getCroppedImg(
				this.imageRef,
				crop,
				'newMarkerFile.jpeg'
			  );
				
			
				
				
			  this.setState({ markerImage });
			
				this.setState({
								tempMarkerImage: markerImage,
				});
				
			}
		  }

			getCroppedImg(image, crop, fileName) {
				const canvas = document.createElement('canvas');
				const scaleX = image.naturalWidth / image.width;
				const scaleY = image.naturalHeight / image.height;
				canvas.width = crop.width;
				canvas.height = crop.height;
				const ctx = canvas.getContext('2d');

				ctx.drawImage(
				  image,
				  crop.x * scaleX,
				  crop.y * scaleY,
				  crop.width * scaleX,
				  crop.height * scaleY,
				  0,
				  0,
				  crop.width,
				  crop.height
				);

				return new Promise((resolve, reject) => {
				  canvas.toBlob(blob => {
					if (!blob) {
					  //reject(new Error('Canvas is empty'));
					  console.error('Canvas is empty');
					  return;
					}
					blob.name = fileName;
					window.URL.revokeObjectURL(this.fileUrl);
					this.fileUrl = window.URL.createObjectURL(blob);
				//	resolve(this.fileUrl);
					  resolve(blob);
				  }, 'image/jpeg');
				});
			  }


			/*checkImageDBExists = () => {
					var storageRef = firebase.storage().ref();
					storageRef.child("images/"+this.state.projectId+"/"+this.state.projectId+".imgdb").getDownloadURL().then(	(() => { 
					this.setState({ imageDB: 'dasfile.imgdb' });
					}), (() => { 
						
						this.setState({
							imageDB: "-----" 
							});
					}));

				 };*/




				downloadImageDB = () => {
					
					
				}
	
				
				checkImageQuality = (imageBlob) => {
					alert("DIE QUALITÄT LAUTET")
					// http://18.184.252.72/converter/converter.php
					//const authToken = localStorage.getItem('AuthToken');

					//axios.defaults.headers.common = { Authorization: `${authToken}` };
					
					const FormData = require('form-data');
					const form = new FormData();
					 form.append('file_name', this.state.projectId)
					 form.append('file', imageBlob)
					
					//https://cors-anywhere.herokuapp.com/http://18.184.252.72/chimg/checkimage.php
					
					axios
					.post(`https://cors-anywhere.herokuapp.com/http://18.184.252.72/chimg/checkimage.php`, form, {
					  maxBodyLength: Infinity,
					  maxContrentLength: Infinity,	
					  headers: {
						"Content-Type": "multipart/form-data",
					  }})
					.then((response) => {

						console.log(" RESULTATE IM CHECKIMAGE");

						alert(response.data['status']);
						alert(response.data['ret']);
						
						

					})
					.catch((err) => {
					console.log("KEINE RESULTATE IM CHECKIMAGE");
						console.log(err);
					});
					
					
				}


	render() {
	
		
		const { classes, ...rest } = this.props;
		
	   const { markerWindowOpen, errors, crop, markerImage, markerSrc, tempMarkerImage} = this.state;

		
		const handleCloseMarkerWindow = (event) => {
			
			
			this.setState({ markerId: '' , markerTitle: '', markerDescription:'' , markerURL:'', markerURLInline:false, markerDirectOpen:false, videoURL:'', markerText:'', externalImageURL:'', externalImageURLLinks:'', galleryView:false, pdfView:false, audioURL:'', fileURl:'', fileURLdescription:'', markerAR: '', markerARtemp: {arSceneDescription: "",active: true, arNodes: []},  markerImage:'', tempMarkerImage:'', markerType:'', markerStyle:'', markerColor:'', overlayStyle:'', markerWidth:'0', markerHeight:'0', geoPoint:{_latitude:0.0, _longitude:0.0}, markerWindowOpen: false, markerSrc: null, markerHidden:false, showMarkerColor:true, showMarkerDirectOpen:false, showMarkerURL: false, showMarkerURLinline:false, showTextMarker:false, showExternalImageURL:false, showVideoURL:false, showAudioURL:false, showFileURL:false, showARMarker:false
						  });	
		
			
			
			
		};
		
		
		
		
		
	
// Sumbit Save Project	prjoect image already generated/uploaded after selection/confirmation	
		
		const handleSubmit = (event) => {
			
			this.setState({
			uiLoading: true
			});
			
			authMiddleWare(this.props.history);
			event.preventDefault();
			
			saveProject();
			
		};
		
		
		const saveProject = () =>{
			const userPoject = {
				projectSubline: this.state.projectSubline,
				projectDescription: this.state.projectDescription,
				projectCode: this.state.projectCode,
				projectTitle: this.state.projectTitle,
				projectActive: this.state.projectActive,
				projectPrivate: this.state.projectPrivate,
				projectExclusive:this.state.projectExclusive,
				projectHideMarkerlist: this.state.projectHideMarkerlist,
				projectColor: this.state.projectColor,
				projectType: this.state.projectType,
				projectDataLink:this.state.projectDataLink,
				visualMarker: this.state.visualMarker,
				geoMarker: this.state.geoMarker,
               categories: this.state.projectCategories

			};
			let options = {};
			
			
			if(this.state.viewMode == "") {

			}
			else{
				if(this.state.viewMode == "editProject") {
					console.log("save project editProject");
					console.log(userPoject.geoMarker);

					options = {
							url: `/project/${this.state.projectId}`,
							method: 'put',
							data: userPoject
						};
				}


				if(this.state.viewMode == "newProject") {

						options = {
							url: '/project',
							method: 'post',
							data: userPoject
						};		
				}
				
		 
			
				console.log("options");
				console.log(options);

				
				// Update or Insert in DB
				const authToken = localStorage.getItem('AuthToken');
				axios.defaults.headers.common = { Authorization: `${authToken}` };
				axios(options)
					.then((response) => {
					
						console.log("inresposne"+response);

						this.setState({
						uiLoading: false
						});
				
					
						if (response.data && response.data.id) {
							this.setState({
								projectId: response.data.id
								});
						}

					    //window.location.reload();
						this.setState({ open: false, viewMode:'editProject' });

				
				})
					.catch((error) => {
						console.log("inerror");
                    
                    console.log('SAVE ERROR STATUS', error.response && error.response.status);
                    console.log('SAVE ERROR DATA', error.response && error.response.data);
                    
                    
					this.setState({
						uiLoading: false
						});
					
						this.setState({ open: true, errors: error.response.data });
						console.log(error);
					});
		
			
			
			}
		
			
		};
		
		
		
		const handleEditMarkerOpenWindow = (event) => {
		
			console.log("GEÖFFNETES FENSTER")
            
            let markerARtemp = {
              arSceneDescription: "",
              active: true,
              arNodes: []
            };

            if (String(event.markerType) === "7" && event.markerAR) {
              try {
                // event.markerAR kommt ESCAPED aus DB
               const unescaped = event.markerAR
                  .replace(/\\"/g, '"')
                  .replace(/\\'/g, "'")
                  .replace(/[\n\r]/g, '');
                markerARtemp = JSON.parse(unescaped);
              } catch (e) {
                console.warn("❌ markerAR JSON konnte nicht geparsed werden", e);
              }
            }
			
			// if checkbox value was not set (f.e. old marker which is edited)
			var urlInlineChecked = false
		
			if((event.markerURLInline == "" ) || (event.markerURLInline == undefined )){
				urlInlineChecked = false
			}
			else{
				
				urlInlineChecked = event.markerURLInline
			}
			
			var markerdirectopenChecked = false
		
			if((event.markerDirectOpen == "" ) || (event.markerDirectOpen == undefined )){
				markerdirectopenChecked = false
			}
			else{
				
				markerdirectopenChecked = event.markerDirectOpen
			}
			
			var markerHiddenChecked = false
		
			if((event.markerHidden == "" ) || (event.markerHidden == undefined )){
				markerHiddenChecked = false
			}
			else{
				
				markerHiddenChecked = event.markerHidden
			}
			
			

			var galleryViewChecked = false
			
			if((event.galleryView == "" ) || (event.galleryView == undefined )){
				galleryViewChecked = false
			}
			else{
				
				galleryViewChecked = event.galleryView
			}
			
			
			var pdfViewChecked = false
			
			if((event.pdfView == "" ) || (event.pdfView == undefined )){
				pdfViewChecked = false
			}
			else{
				
				pdfViewChecked = event.pdfView
			}
			
			

			
		this.setState({
			title: "Edit visual Marker",
			buttonType: 'Edit',
			markerWindowOpen: true,
			viewModeMarker: 'editMarker',
			markerTitle: event.markerTitle,
			markerDescription: event.markerDescription,
			markerURL: event.markerURL,
			markerURLInline: urlInlineChecked,
			markerDirectOpen: markerdirectopenChecked,
			videoURL: event.videoURL,
			markerText: event.markerText,
			markerImage: event.markerImage,
			externalImageURL: event.externalImageURL,
			externalImageURLLinks: event.externalImageURLLinks,
			galleryView: galleryViewChecked,
			pdfView:pdfViewChecked,
			audioURL: event.audioURL,
			fileURL: event.fileURL,
			fileURLdescription: event.fileURLdescription,
			markerAR: event.markerAR || "",   // STRING für Save
            markerARtemp: markerARtemp,       // 🔥 OBJEKT für SceneEditor
            markerType : event.markerType,
			markerStyle: event.markerStyle,
			markerColor: event.markerColor,
			overlayStyle: event.overlayStyle,
			markerHidden: markerHiddenChecked,
			markerWidth : event.markerWidth,
			geoPoint: event.geoPoint,
			markerHeight : event.markerHeight,
			markerId:  event.markerId,
            oldMarkerImage: event.markerImage
		});	
			
			if(event.markerStyle == "frame"){
			 	this.setState({showMarkerColor: false, showMarkerDirectOpen:true})
				
			}
			
			if((event.markerStyle == "icon") || (event.markerStyle == "")){
			 	this.setState({showMarkerColor: true, showMarkerDirectOpen:false})
				
			}
		
			

			 if(event.markerType == ""){
				   	this.setState({showMarkerURL: false,
								   showMarkerURLinline: false,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:false,
								  })
			   }
			
			
			   if(event.markerType == "1"){
				   	this.setState({showMarkerURL: true,		
 									showMarkerURLinline: true,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:false,
								  })
			   }
			
			if(event.markerType == "2"){
				   		this.setState({showMarkerURL: false,
 									showMarkerURLinline: false,
									showTextMarker:true,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:false,
								  })

			   }
			
			if(event.markerType == "3"){
				   	   		this.setState({showMarkerURL: false,
 									showMarkerURLinline: false,
									showTextMarker:false,
									showExternalImageURL:true,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:false,
								  })

			   }
			
			   if(event.markerType == "4"){
				   	this.setState({showMarkerURL: false,
 									showMarkerURLinline: false,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:true,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:false,
								  })

			   }
			
			if(event.markerType == "5"){
				      	this.setState({showMarkerURL: false,
 									showMarkerURLinline: false,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:true,
									showFileURL:false,
									showARMarker:false,
								  })

			   }
			
			if(event.markerType == "6"){
				   	this.setState({showMarkerURL: false,
 									showMarkerURLinline: false,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:true,
									showARMarker:false,
								  })

			   }
		   	 if(event.markerType == "7"){
				   		this.setState({showMarkerURL: false,
 									showMarkerURLinline: false,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:true,
								  })
			   }	
		
		}
		
		
		
		
		
		
		
		
		
		const handleEditGeoMarkerOpenWindow = (event) => {
		
			
			// if checkbox value was not set (f.e. old marker which is edited)
			var urlInlineChecked = false
		
			if((event.markerURLInline == "" ) || (event.markerURLInline == undefined )){
				urlInlineChecked = false
			}
			else{
				
				urlInlineChecked = event.markerURLInline
			}
			
			var markerdirectopenChecked = false
		
			if((event.markerDirectOpen == "" ) || (event.markerDirectOpen == undefined )){
				markerdirectopenChecked = false
			}
			else{
				
				markerdirectopenChecked = event.markerDirectOpen
			}
			
			var markerHiddenChecked = false
		
			if((event.markerHidden == "" ) || (event.markerHidden == undefined )){
				markerHiddenChecked = false
			}
			else{
				
				markerHiddenChecked = event.markerHidden
			}
			
			

			var galleryViewChecked = false
			
			if((event.galleryView == "" ) || (event.galleryView == undefined )){
				galleryViewChecked = false
			}
			else{
				
				galleryViewChecked = event.galleryView
			}
			
			
			var pdfViewChecked = false
			
			if((event.pdfView == "" ) || (event.pdfView == undefined )){
				pdfViewChecked = false
			}
			else{
				
				pdfViewChecked = event.pdfView
			}
			
			

			
		this.setState({
			title: "Edit Geo Marker",
			buttonType: 'Edit',
			markerWindowOpen: true,
			viewModeMarker: 'editGeoMarker',
			markerTitle: event.markerTitle,
			markerDescription: event.markerDescription,
			markerURL: event.markerURL,
			markerURLInline: urlInlineChecked,
			markerDirectOpen: markerdirectopenChecked,
			videoURL: event.videoURL,
			markerText: event.markerText,
			markerImage: event.markerImage,
			externalImageURL: event.externalImageURL,
			externalImageURLLinks: event.externalImageURLLinks,
			galleryView: galleryViewChecked,
			pdfView:pdfViewChecked,
			audioURL: event.audioURL,
			fileURL: event.fileURL,
			fileURLdescription: event.fileURLdescription,
			markerAR: event.markerAR,	
			markerType : event.markerType,
			markerStyle: event.markerStyle,
			markerColor: event.markerColor,
			overlayStyle: event.overlayStyle,
			markerHidden: markerHiddenChecked,
			markerWidth : event.markerWidth,
			geoPoint: event.geoPoint,
			markerHeight : event.markerHeight,
			markerId:  event.markerId,
            oldMarkerImage: event.markerImage
		});	
			
			if(event.markerStyle == "frame"){
			 	this.setState({showMarkerColor: false, showMarkerDirectOpen:true})
				
			}
			
			if((event.markerStyle == "icon") || (event.markerStyle == "")){
			 	this.setState({showMarkerColor: true, showMarkerDirectOpen:false})
				
			}
		
			

			 if(event.markerType == ""){
				   	this.setState({showMarkerURL: false,
								   showMarkerURLinline: false,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:false,
								  })
			   }
			
			
			   if(event.markerType == "1"){
				   	this.setState({showMarkerURL: true,		
 									showMarkerURLinline: true,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:false,
								  })
			   }
			
			if(event.markerType == "2"){
				   		this.setState({showMarkerURL: false,
 									showMarkerURLinline: false,
									showTextMarker:true,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:false,
								  })

			   }
			
			if(event.markerType == "3"){
				   	   		this.setState({showMarkerURL: false,
 									showMarkerURLinline: false,
									showTextMarker:false,
									showExternalImageURL:true,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:false,
								  })

			   }
			
			   if(event.markerType == "4"){
				   	this.setState({showMarkerURL: false,
 									showMarkerURLinline: false,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:true,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:false,
								  })

			   }
			
			if(event.markerType == "5"){
				      	this.setState({showMarkerURL: false,
 									showMarkerURLinline: false,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:true,
									showFileURL:false,
									showARMarker:false,
								  })

			   }
			
			if(event.markerType == "6"){
				   	this.setState({showMarkerURL: false,
 									showMarkerURLinline: false,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:true,
									showARMarker:false,
								  })

			   }
		   	 if(event.markerType == "7"){
				   		this.setState({showMarkerURL: false,
 									showMarkerURLinline: false,
									showTextMarker:false,
									showExternalImageURL:false,
									showVideoURL:false,
									showAudioURL:false,
									showFileURL:false,
									showARMarker:true,
								  })
			   }	
		
		}
		
		
		
		
		
		
		
		
		
		
		
		const handleDeleteMarker = (event) => {
			
			console.log("CLICK"+event.markerId)
			
			
			var answer = window.confirm("Jetzt löschen?");
			if (answer) {
				//some code
				
				var tempArray = this.state.visualMarker.filter(function( obj ) {
						return obj.markerId !== event.markerId;
					});
				
				this.setState({ visualMarker:tempArray});	

				
				/*	
				let options = {};
				options = {
							url: `/marker/${event.markerId}`,
							method: 'delete',
				};*/
			
				
				
				
				
					  var projectName = this.state.projectTitle
					   projectName=projectName.replace(/\s/g, '_');
					   projectName = projectName.toLowerCase();

						projectName = this.state.projectId;
					
					var markerName= "";
 						markerName = event.markerTitle;
						markerName= markerName.replace(/\s/g, '_');
		   				markerName = markerName.toLowerCase();
					
				
					var markerImageFileType = "jepg";	
				
				
					 var startpos_filetype = event.markerImage.lastIndexOf( "." )+1
						 var endpos_filetype = event.markerImage.lastIndexOf( "?" )
						 
						 console.log("MIMAGE:"+event.markerImage)
						    console.log("Startpos"+startpos_filetype)
						    console.log("Endpos"+endpos_filetype)

						 if((startpos_filetype != -1 )&&(endpos_filetype != -1)){

							  markerImageFileType = event.markerImage.substring(startpos_filetype, endpos_filetype)
							  console.log("FILETYPE"+markerImageFileType)
						 
						 						 
								var uploadPath = "images/"+projectName+"/"+markerName+"."+markerImageFileType;
								var storageRef = firebase.storage().ref();
								var uploadRef = storageRef.child(`${uploadPath}`);

							  console.log("uploadPath"+uploadPath)


								uploadRef.delete().then(() => {
								  // File deleted successfully
									saveProject();
								}).catch((error) => {
								  // Uh-oh, an error occurred!
								});

						 }
				
			}
				
			};	
				
			/*
			const authToken = localStorage.getItem('AuthToken');
				axios.defaults.headers.common = { Authorization: `${authToken}` };
				axios(options)
					.then(() => {
						this.setState({ open: false });
						//window.location.reload();
					
					
					  var projectName = this.state.projectTitle
					   projectName=projectName.replace(/\s/g, '_');
					   projectName = projectName.toLowerCase();

						projectName = this.state.projectId;
					
					var markerName= "";
 						markerName = event.markerTitle;
						markerName= markerName.replace(/\s/g, '_');
		   				markerName = markerName.toLowerCase();
					
				
					var markerImageFileType = "jepg";	
					
				   console.log("FILETYPE"+event.markerImage)

					if(event.markerImage.type){
					   
					   
					   }
					   
					 else{
						 
						 var startpos_filetype = event.markerImage.lastIndexOf( "." )+1
						 var endpos_filetype = event.markerImage.lastIndexOf( "?" )
						 
						 
						    console.log("Startpos"+startpos_filetype)
						    console.log("Endpos"+endpos_filetype)

						 if((startpos_filetype != -1 )&&(endpos_filetype != -1)){

							  markerImageFileType = event.markerImage.substring(startpos_filetype, endpos_filetype)
							  console.log("FILETYPE"+markerImageFileType)
						 
						 						 
								var uploadPath = "images/"+projectName+"/"+markerName+"."+markerImageFileType;
								var storageRef = firebase.storage().ref();
								var uploadRef = storageRef.child(`${uploadPath}`);

							  console.log("uploadPath"+uploadPath)


								uploadRef.delete().then(() => {
								  // File deleted successfully
								}).catch((error) => {
								  // Uh-oh, an error occurred!
								});

						 }
						 
					   }  
					
					
					
					
					})
					.catch((error) => {
						console.log(error);
					});
				
				
			}
			else {
				//some code
			}

			
			
			
			
			
		};*/
		
			const handleFinalDelete = (event) => {
			
				
			}
			
			
		const replaceUmlaute = (str) =>{
		  return str
			.replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, (a) => {
			  const big = umlautMap[a.slice(0, 1)];
			  return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1);
			})
			.replace(new RegExp('['+Object.keys(umlautMap).join('|')+']',"g"),
			  (a) => umlautMap[a]
			);
		}
	
		
	
		
		const addMarker = (marker, event, imageChangeFlag, markerType) => {
			
					authMiddleWare(this.props.history);
			
					
					var markerFormIsValid = validateMarkerForm(marker);
					
					console.log("INADDFUNCTION");

					
			
					if (markerFormIsValid){
					
					console.log("markerFormIsValid");


					var projectName = this.state.projectTitle
					   projectName=projectName.replace(/\s/g, '_');
					   projectName = projectName.toLowerCase();

						projectName = this.state.projectId;
					
					var markerName= "";
 						markerName = marker.markerTitle;
					    markerName = markerName.trim()
						markerName = replaceUmlaute(markerName);
						markerName= markerName.replace(/\s/g, '_');
		   				markerName = markerName.toLowerCase();
						
					
			
					var markerImageFileType = "jepg";	
					markerImageFileType = marker.markerImage.type.substring(marker.markerImage.type.lastIndexOf( "/" )+1);
				
					
					var uploadPath = "images/"+projectName+"/"+markerName+"."+markerImageFileType;
					
					var markerImageBlob = marker.markerImage
					marker.markerImage = markerName+"."+markerImageFileType;
				
					var storageRef = firebase.storage().ref();
					var uploadRef = storageRef.child(`${uploadPath}`);
			
					//upload Marker Image
					uploadRef.put(markerImageBlob).then((snapshot) => {
						
						console.log("addMArkerFunctionmarkerImageBlob")

					
						var addoptions = {
							url: `/marker/${this.state.projectId}`,
							method: 'post',
							data: marker
						};		
						
						
						
						var markerTempImageUrl = "https://firebasestorage.googleapis.com/v0/b/moval-4c0b4.appspot.com/o/images%2F"+projectName+"%2F"+markerName+"."+markerImageFileType+"?alt=media";
						marker.markerImage = markerTempImageUrl
						console.log(marker)
						console.log(this.state.visualMarker)
						console.log(this.state.geoMarker)

						console.log(this.state.projectType)
						
						if(this.state.projectType == 1){
							
						
							if(this.state.visualMarker != undefined){
								console.log("visualMarkernotundefined")


							var tempArray = this.state.visualMarker
							tempArray.unshift(marker)

							}

							else{
								console.log("visualMarkerdefined")
								var tempArray = new Array();
								tempArray.unshift(marker)
							}

							this.setState({visualMarker:tempArray});

						
						}
						
						else{



							if(this.state.geoMarker != undefined){
							var tempGeoArray = this.state.geoMarker
							tempGeoArray.unshift(marker)

							}

							else{
								var tempGeoArray = new Array();
								tempGeoArray.unshift(marker)
							}

							this.setState({geoMarker:tempGeoArray});
						
						}
						
						
						
						console.log("addMArkerFunctionEND")
						
						saveProject();
						
						var tempZeroGeoMarker = {_latitude:0.0, _longitude:0.0}

						
						this.setState({ markerId: '' , markerTitle: '', markerDescription:'' , markerURL:'', markerURLInline:false, videoURL:'', markerType:'', markerStyle:'', markerColor:'', overlayStyle:'', markerDirectOpen:false, markerWidth:'0', geoPoint:tempZeroGeoMarker, markerHeight:'0',tempMarkerImage:'', markerImage:'', markerText:'',externalImageURL:'',externalImageURLLinks:'', galleryView:false, pdfView:false, audioURL:'', fileURL:'', fileURLdescription:'', markerAR:'', showMarkerColor:true, showMarkerDirectOpen:false, showMarkerURL: false, showMarkerURLinline:false, showTextMarker:false, showExternalImageURL:false, showVideoURL:false, showAudioURL:false, showFileURL:false, showARMarker:false, markerSrc:null, markerHidden:false, uiLoading: false,  markerWindowOpen: false  });

					 //Perform DB upload change Image
						/*
						const authToken = localStorage.getItem('AuthToken');
						axios.defaults.headers.common = { Authorization: `${authToken}` };
						axios(addoptions)
							.then((response) => {

								console.log("WAS KAM ZURÜCK nach dem einfügen")
								console.log(response)
								//window.location.reload();
								this.setState({ open: false, projectId: response.data.projectId, viewMode:'editProject' });
								marker.markerId = response.data.id
							
								var tempArray = this.state.visualMarker
								tempArray.unshift(marker)
							
							
								console.log("Das neue Visual Mrker Array")
								console.log(tempArray)

								// add new Marker to state (visualMarker)
								this.setState({ markerWindowOpen: false , visualMarker:tempArray, uiLoading: false});	
				
	
				
			//clean states
				
							this.setState({ markerId: '' , markerTitle: '', markerDescription:'' , markerURL:'',videoURL:'', markerType:'', markerWidth:'', markerHeight:'',tempMarkerImage:'', markerImage:'', markerText:'',externalImageURL:'', audioURL:'', fileURL:'', markerAR:'', showMarkerURL: false, showTextMarker:false, showExternalImageURL:false, showVideoURL:false, showAudioURL:false, showFileURL:false, showARMarker:false, markerSrc:null });	
							
					

							
						})
							.catch((error) => {
								this.setState({
										uiLoading: false
									});
							
								this.setState({ open: true, errors: error.response.data });
								console.log("FEHLER EI MARKER ADD DB"+error);
							});

						*/
					
					
					
				});
			   
			   
			  marker.markerImage = markerName+"."+markerImageFileType
			
				}
			
			else{
									console.log("markerFormIsNOTValid");

				this.setState({
					uiLoading: false
				});
			
			}
		}
	
			
			
			
		const updateMarker = (marker,event, imageChangeFlag) => {
			
			authMiddleWare(this.props.history);
			
			
			alert(this.state.markerId);
			
			var markerFormEditIsValid = validateMarkerForm(marker);
			
			if (markerFormEditIsValid){

				

			if(imageChangeFlag == 1){
				
			if(marker.markerImage instanceof Blob){
			   
			
					  var projectName = this.state.projectTitle
					   projectName=projectName.replace(/\s/g, '_');
					   projectName = projectName.toLowerCase();

						projectName = this.state.projectId;
					
					var markerName= "";
 						markerName = marker.markerTitle;
					    markerName = markerName.trim()
						markerName= markerName.replace(/\s/g, '_');
		   				markerName = markerName.toLowerCase();
					
				
					var markerImageFileType = "jepg";	
					markerImageFileType = marker.markerImage.type.substring(marker.markerImage.type.lastIndexOf( "/" )+1);
				
					
					var uploadPath = "images/"+projectName+"/"+markerName+"."+markerImageFileType;
					
					var markerImageBlob = marker.markerImage
					marker.markerImage = markerName+"."+markerImageFileType;
				
					var storageRef = firebase.storage().ref();
					var uploadRef = storageRef.child(`${uploadPath}`);

			
					
					
				uploadRef.put(markerImageBlob).then((snapshot) => {
					  console.log('Uploaded a blob or file!');
					

						authMiddleWare(this.props.history);
					    event.preventDefault();

						let editmarkeroptions =  {
										url: `/marker/${marker.markerId}`,
										method: 'put',
										data: marker
						};
					const authToken = localStorage.getItem('AuthToken');
					
					
					var tempArray = this.state.visualMarker
					var tempGeoArray = this.state.geoMarker

					var objIndex = tempArray.findIndex((obj => obj.markerId == marker.markerId));	
					var objGeoIndex = tempGeoArray.findIndex((obj => obj.markerId == marker.markerId));	

				
					var markerTempImageUrl = "https://firebasestorage.googleapis.com/v0/b/moval-4c0b4.appspot.com/o/images%2F"+projectName+"%2F"+markerName+"."+markerImageFileType+"?alt=media";
					
						marker.markerImage = markerTempImageUrl
					    tempArray [objIndex] = marker
						tempGeoArray [objGeoIndex] = marker

					

					
					var tempZeroGeoMarker = {_latitude:0.0, _longitude:0.0}

					this.setState({ markerId: '' , markerTitle: '', markerDescription:'' , markerURL:'', markerURLInline:false, markerDirectOpen:false, videoURL:'', markerText:'', markerImage:'', markerSrc: null, externalImageURL:'',externalImageURLLinks:'', galleryView:false, pdfView:false, audioURL:'', fileURl:'', fileURLdescription:'', markerAR:'',  markerType:'', markerStyle:'', markerColor:'', overlayStyle:'', markerWidth:'0', geoPoint: tempZeroGeoMarker, markerHeight:'0',visualMarker: tempArray, geoMarker: tempGeoArray, showMarkerColor:true, showMarkerDirectOpen:false, showMarkerURL: false, showMarkerURLinline:false, showTextMarker:false, showExternalImageURL:false, showVideoURL:false, showAudioURL:false, showFileURL:false, showARMarker:false, markerSrc:null, markerHidden: false});
							
							
				    saveProject();			
							
				   this.setState({ markerWindowOpen: false, uiLoading:false });

					/*
					axios.defaults.headers.common = { Authorization: `${authToken}` };
						axios(editmarkeroptions)
							.then((response) => {

								console.log("WAS KAM ZURÜCK nach dem marker edit")
								console.log(response)
							
							marker.markerImage = markerName+"."+markerImageFileType
							
							
							console.log("IN EDITED")
							console.log(markerName)
							console.log(marker.markerImage)
							
							var tempArray = this.state.visualMarker
							var objIndex = tempArray.findIndex((obj => obj.markerId == marker.markerId));	
							tempArray [objIndex] = marker



						this.setState({ markerId: '' , markerTitle: '', markerDescription:'' , markerURL:'', videoURL:'', markerText:'', markerImage:'', markerSrc: null, externalImageURL:'', audioURL:'', fileURl:'', markerAR:'',  markerType:'', markerWidth:'', markerHeight:'',visualMarker: tempArray, showMarkerURL: false, showTextMarker:false, showExternalImageURL:false, showVideoURL:false, showAudioURL:false, showFileURL:false, showARMarker:false, markerSrc:null  });
							
							
						saveProject();			
							
				 this.setState({ markerWindowOpen: false, uiLoading:false });
						})
					
					
					
					
							.catch((error) => {
							this.setState({
							uiLoading: false
							});
							
								console.log("WAS KAM ZURÜCK nach dem fehlerhaften marker edit")
								console.log(error.response.data)
								this.setState({ open: true, errors: error.response.data });
								console.log(error);
							});
						*/
					
					/*
					this.setState({ markerWindowOpen: false });
				this.setState({ markerId: '' , markerTitle: '', markerDescription:'' , markerURL:'', videoURL:'', markerText:'', externalImageURL:'', audioURL:'', fileURl:'', markerAR:'',  markerType:'', markerWidth:'', markerHeight:'' });	
					*/
					
				});
			   
			   
			   
			   }
			}
			
			else{
				
				
					authMiddleWare(this.props.history);
					event.preventDefault();
				
				console.log("update MArker2NotChangedImage");
				//console.log(this.state.geoPoint._latitude)
				
				var tempArray = this.state.visualMarker
				var tempGeoArray = this.state.geoMarker

				
				if(this.state.projectType == 1){
				console.log("tempArray length");
				console.log(tempArray.length);
				var objIndex = tempArray.findIndex((obj => obj.markerId == marker.markerId));	
				}
				else{
				console.log("tempGeoArray length");
				console.log(tempGeoArray.length);
				var objGeoIndex = tempGeoArray.findIndex((obj => obj.markerId == marker.markerId));	
					
				}

				

				

				console.log("update MArker2objGeoIndex");
				
				projectName = this.state.projectId
				
				var markerTempImageUrl = "https://firebasestorage.googleapis.com/v0/b/moval-4c0b4.appspot.com/o/images%2F"+projectName+"%2F"+marker.markerImage+"?alt=media";
				marker.markerImage = markerTempImageUrl
				
				
				if(this.state.projectType == 1){
					tempArray [objIndex] = marker
					var tempGeoArray = [];
				}
				else{
					tempGeoArray [objGeoIndex] = marker
					var tempArray = [];
				}
					
				
				
				
					var tempZeroGeoMarker = {_latitude:0.0, _longitude:0.0}
				this.setState({ markerId: '' , markerTitle: '', markerDescription:'' , markerURL:'', markerURLInline:false, markerDirectOpen:false, videoURL:'', markerText:'', externalImageURL:'',externalImageURLLinks:'', galleryView:false, pdfView:false, audioURL:'', fileURl:'', fileURLdescription:'', markerAR:'',  markerType:'', markerStyle:'', markerColor:'', overlayStyle:'', markerWidth:'0', geoPoint:tempZeroGeoMarker, markerHeight:'0',visualMarker: tempArray, geoMarker: tempGeoArray, markerImage:'', markerSrc: null, markerHidden:false});	
				
				
				console.log("update MArker3NotChangedImage");
				console.log(this.state.geoMarker)	
				saveProject();	
				
				
				this.setState({
							uiLoading: false
					})
				 this.setState({ markerWindowOpen: false });

				
			/*
			let editmarkeroptions =  {
							url: `/marker/${marker.markerId}`,
							method: 'put',
							data: marker
			};
			const authToken = localStorage.getItem('AuthToken');

			axios.defaults.headers.common = { Authorization: `${authToken}` };
				axios(editmarkeroptions)
					.then((response) => {
						
						console.log("WAS KAM ZURÜCK nach dem marker edit")
						console.log(response)
					    //window.location.reload();
					
					var tempArray = this.state.visualMarker
					var objIndex = tempArray.findIndex((obj => obj.markerId == marker.markerId));	
					tempArray [objIndex] = marker
					
					
					
				this.setState({ markerId: '' , markerTitle: '', markerDescription:'' , markerURL:'', videoURL:'', markerText:'', externalImageURL:'', audioURL:'', fileURl:'', markerAR:'',  markerType:'', markerWidth:'', markerHeight:'',visualMarker: tempArray, markerImage:'', markerSrc: null  });	
		 this.setState({ markerWindowOpen: false });
					
					saveProject();	
				
					
					this.setState({
							uiLoading: false
					});
				})
					.catch((error) => {
					
					this.setState({
					uiLoading: false
									});
					
						console.log("WAS KAM ZURÜCK nach dem fehlerhaften marker edit")
						console.log(error.response.data)
						this.setState({ open: true, errors: error.response.data });
						console.log(error);
					});
				
				*/

			}
			
			}
			else{
				
					this.setState({
					uiLoading: false
									});
			}
			
		}
		
		const validateMarkerForm = (marker) =>{
			
			var markerFormIsValid = true;
			
			
					if(marker.markerTitle == ""){
						markerFormIsValid = false
						this.setState({
							showMarkerTitleHelper: true
						});
						
					}
					if (marker.markerType == ""){
						markerFormIsValid = false
						this.setState({
							showMarkerTypeHelper: true
						});
					}
			
			
					if(this.state.projectType == 1){

						alert("visual");
						if (marker.markerWidth == ""){
							markerFormIsValid = false
							this.setState({
								showMarkerWidthHelper: true
							});
						}

						if (marker.markerHeight == ""){
							markerFormIsValid = false
							this.setState({
								showMarkerHeightHelper: true
							});
						}
			
					}
			
			
			
					if(this.state.projectType == 2){
						
						marker.markerWidth = "0"
							marker.markerHeight = "0"
						
						if (marker.geoPoint._latitude == 0){
							markerFormIsValid = false
							
							alert(marker.geoPoint._latitude);
							
							

							this.setState({
								showMarkerWidthHelper: true
							});
						}

						if (marker.geoPoint._longitude == 0){
							
							alert(marker.geoPoint._longitude);
							
							markerFormIsValid = false
							this.setState({
								showMarkerWidthHelper: true
							});
						}
							
					}

			
			
			
			
			
					if (marker.markerImage== ""){
						markerFormIsValid = false
						this.setState({
							showMarkerImageHelper: true
						});
					}
			
			
			return markerFormIsValid
			
		}
		

		const createRandomMarkerId = (length) =>{
			var result           = '';
			var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			var charactersLength = characters.length;
			for ( var i = 0; i < length; i++ ) {
			  result += characters.charAt(Math.floor(Math.random() * 
		 charactersLength));
		   }
		   return result;
		}
		
		
		
		
		// Marker form submit / Save , new markers and changes of existing markers are performed when !!save project!!
		const handleMarkerSubmit = (event) => {
			
				authMiddleWare(this.props.history);

				this.setState({
					uiLoading: true
				});
			
		
			if(this.state.viewModeMarker == "addMarker"){
				console.log("addMarker");

				var htmlArMarker = "";
                if (this.state.markerARtemp && String(this.state.markerType) === "7") {
                  htmlArMarker = JSON.stringify(this.state.markerARtemp).replace(/"/g, '\\"');
                } else if (this.state.markerAR) {
                  htmlArMarker = this.state.markerAR.replace(/"/g, '\\"');
                }
				
				var markerText = ""
				if((this.state.markerText != "") && (this.state.markerText != undefined)){
				markerText = this.state.markerText.replace(/\\"/g, '"').replace(/"/g, '\\"');
				}
				
				
				//byte[] utf8 = this.state.markerAR.getBytes("UTF8");
				//var htmlArMarker= new String(new Base64().encode(utf8));
				
				
				//blob image
				var tempMarker = this.state.tempMarkerImage;
		
				// Create new Marker Object: Attributes stored temporarily in State var, blob image in tempMarker
				
				
				if(this.state.projectType == 2){
										console.log("save2");

					var tempGeoPoint = {_latitude: this.state.geoPoint._latitude, _longitude:  this.state.geoPoint._longitude}

				}
				else{
					console.log("standardsave");
					var tempGeoPoint = {_latitude: 0, _longitude:  0}	
				}
				
				
				var newMarker = {
				createdAt: new Date().toISOString(),	
				markerTitle: this.state.markerTitle,
				markerDescription: this.state.markerDescription,
				markerURL: this.state.markerURL,
				markerURLInline: this.state.markerURLInline,	
				markerDirectOpen: this.state.markerDirectOpen,
				videoURL: this.state.videoURL,
				markerText: markerText,
				externalImageURL: this.state.externalImageURL,
				externalImageURLLinks:this.state.externalImageURLLinks,	
				galleryView:this.state.galleryView,	
				pdfView:this.state.pdfView,	
				audioURL: this.state.audioURL,
				fileURL: this.state.fileURL,
				fileURLdescription: this.state.fileURLdescription,	
				//markerAR: this.state.markerAR,	
				markerAR: htmlArMarker,
				markerImage: tempMarker,
				markerType : this.state.markerType,
				markerStyle: this.state.markerStyle,
				markerColor: this.state.markerColor,
				overlayStyle: this.state.overlayStyle,	
				markerHidden: this.state.markerHidden,
				markerWidth : this.state.markerWidth,
				markerHeight : this.state.markerHeight,
				markerId: createRandomMarkerId(8),
				projectId: this.state.projectId,
				geoPoint: tempGeoPoint	
			}
				
			
			// perform visual add to list and direct Upload of Marker and DB change 
				// last parameter marker:  0 = geoMarker
			addMarker(newMarker, event, imageChangeFlag, 0)
	
			}
			
			
			
			
			if(this.state.viewModeMarker == "addGeoMarker"){
				console.log("addGeoMarker");
				var htmlArMarker = ""
				
				if((this.state.markerAR != "") && (this.state.markerAR != undefined)){
				htmlArMarker = this.state.markerAR.replace(/\\"/g, '"').replace(/"/g, '\\"');
				}
				
				var markerText = ""
				if((this.state.markerText != "") && (this.state.markerText != undefined)){
				markerText = this.state.markerText.replace(/\\"/g, '"').replace(/"/g, '\\"');
				}
				
				
				//byte[] utf8 = this.state.markerAR.getBytes("UTF8");
				//var htmlArMarker= new String(new Base64().encode(utf8));
				
				
				//blob image
				var tempMarker = this.state.tempMarkerImage;
				
				var tempGeoPoint = {_latitude: this.state.geoPoint._latitude , _longitude: this.state.geoPoint._longitude};
		
				// Create new Marker Object: Attributes stored temporarily in State var, blob image in tempMarker
				var newGeoMarker = {
					
				createdAt: new Date().toISOString(),	
				markerTitle: this.state.markerTitle,
				markerDescription: this.state.markerDescription,
				markerURL: this.state.markerURL,
				markerURLInline: this.state.markerURLInline,	
				markerDirectOpen: this.state.markerDirectOpen,
				videoURL: this.state.videoURL,
				markerText: markerText,
				externalImageURL: this.state.externalImageURL,
				externalImageURLLinks:this.state.externalImageURLLinks,	
				galleryView:this.state.galleryView,	
				pdfView:this.state.pdfView,	
				audioURL: this.state.audioURL,
				fileURL: this.state.fileURL,
				fileURLdescription: this.state.fileURLdescription,	
				//markerAR: this.state.markerAR,	
				markerAR: htmlArMarker,
				markerImage: tempMarker,
				markerType : this.state.markerType,
				markerStyle: this.state.markerStyle,
				markerColor: this.state.markerColor,
				overlayStyle: this.state.overlayStyle,	
				markerHidden: this.state.markerHidden,
				markerWidth : this.state.markerWidth,
				markerHeight : this.state.markerHeight,
				markerId: createRandomMarkerId(8),
				projectId: this.state.projectId,
				geoPoint: tempGeoPoint	
			}
				
			console.log(newGeoMarker)
			
			// perform visual add to list and direct Upload of Marker and DB change 
			addMarker(newGeoMarker, event, imageChangeFlag, 1)
	
			}
			
			
			
			
			
			
			
			
			
			
			
			if(this.state.viewModeMarker == "editMarker"){
				
				var imageChangeFlag = 0
				
			     var mImage = this.state.markerImage
				//was markerImage changed?
				 if(this.state.markerImage instanceof Blob){
					 
					mImage = this.state.tempMarkerImage;
					 
					 imageChangeFlag = 1
					 

				 }
				else{
					
					if(this.state.markerImage.lastIndexOf("%2F")!= -1){
						
						
						var endPos = this.state.markerImage.lastIndexOf("?alt=media")
						
						mImage = this.state.markerImage.substring(this.state.markerImage.lastIndexOf("%2F")+3,endPos)  
					}
					
				}
				
				var htmlArMarker = ""
				if((this.state.markerAR != "") && (this.state.markerAR != undefined)){
				htmlArMarker = this.state.markerAR.replace(/\\"/g, '"').replace(/"/g, '\\"').replace(/[\n\r]/g, '');
				}
				
				var markerText = ""
				if((this.state.markerText != "") && (this.state.markerText != undefined)){
				markerText = this.state.markerText.replace(/\\"/g, '"').replace(/"/g, '\\"').replace(/[\n\r]/g, '');
				}
				
				console.log("edited MArker");
				
				/*if(this.state.geoPoint){
									console.log("edited MArker IN TRUE");

				console.log(this.state.geoPoint._latitude)

				}
				else{
					console.log("edited var temp MArker IN FALSE");

				var tempGeoPoint = {_latitude: 0, _longitude:  0}
	
				}*/
                
                const tempGeoPoint = this.state.geoPoint
                  ? { _latitude: this.state.geoPoint._latitude, _longitude: this.state.geoPoint._longitude }
                  : { _latitude: 0, _longitude: 0 };
				
				var editedMarker = {
				markerId: this.state.markerId,
				markerTitle: this.state.markerTitle,
				markerDescription: this.state.markerDescription,
				markerURL: this.state.markerURL,
				markerURLInline: this.state.markerURLInline,	
				markerDirectOpen: this.state.markerDirectOpen,	
				videoURL: this.state.videoURL,	
				markerText: markerText,
				externalImageURL: this.state.externalImageURL,
				externalImageURLLinks:this.state.externalImageURLLinks,	
				galleryView:this.state.galleryView,	
				pdfView:this.state.pdfView,	
				audioURL: this.state.audioURL,
				fileURL: this.state.fileURL,
				fileURLdescription: this.state.fileURLdescription,	
				//markerAR: this.state.markerAR,
				markerAR: htmlArMarker,
				markerImage: mImage,
				markerType : this.state.markerType,
				markerStyle: this.state.markerStyle,
				markerColor: this.state.markerColor,
				overlayStyle: this.state.overlayStyle,	
				markerHidden: this.state.markerHidden,					
				markerWidth : this.state.markerWidth,
				markerHeight : this.state.markerHeight,	
				geoPoint: tempGeoPoint,
				projectId:  this.state.projectId,	
				}
				
				
				
				if(this.state.markerId != ''){
				updateMarker(editedMarker, event, imageChangeFlag)
				}
				else{
					
					this.setState({
										uiLoading: false
									});
				}

			}
			
			
			
			
			
			
			
			
			
		};
		
		
		
		
		
		if (this.state.uiLoading === true) {
			return (
				<main className={classes.content}>
					<div className={classes.toolbar} />
					{this.state.uiLoading && <CircularProgress size={150} className={classes.uiProgess} />}
				</main>
			);
		} else {
			
				// If images currently uploading
			if (this.state.forcedReload.length > 0 ){
				return (
					<main className={classes.content}>
						<div className={classes.toolbar} />
						{this.state.uiLoading && <CircularProgress size={150} className={classes.uiProgess} />}
					</main>
				);
			}
			
			else{
				
		
				
			var markerImageUrl = markerImage
			if(markerImage){
				
				// If marker image was saved to Firebase (project saved), the absolute URL of visual marker is generated at initial call =>
				 if(markerImage instanceof Blob){
					 
					  markerImageUrl = URL.createObjectURL(markerImage)

					 
				 }
				else{
					if(markerImage.includes('https')){
					markerImageUrl = markerImage
						
					}	

					// If marker image is blob, the marker was saved but not the project => generated blob URL
					else{
						
					var projectName = this.state.projectId;
					markerImageUrl = "https://firebasestorage.googleapis.com/v0/b/moval-4c0b4.appspot.com/o/images%2F"+projectName+"%2F"+markerImage+"?alt=media";	

					//  markerImageUrl = URL.createObjectURL(markerImage)

					}	
				
				}
				
			}
			
		var tempProjectImageURL =""
		var tempProjectLogoImageURL =""
		var projectImage = ""
		var projectLogoImage = ""
		var project_ID = ""

		
		if((this.state.currentprojectimage !="") && (this.state.currentprojectimage != undefined)) {
			
			console.log("Was ist das für ein File File")
			console.log(this.state.currentprojectimage)
			console.log(this.state)

			console.log(this.state.projectId)
			var project_ID = ""+this.state.projectId
			console.log(project_ID)

			var cHashp = Math.random().toString(16).substr(2, 8);	
			tempProjectImageURL = "https://firebasestorage.googleapis.com/v0/b/moval-4c0b4.appspot.com/o/images%2F"+project_ID+"%2F"+this.state.currentprojectimage+"?alt=media&cHash="+cHashp;	
			
			projectImage = <div className="image_wrapper">
												<img alt="Project Image" className="previewprojectimage" style={{ maxWidth: '300' }} id={"projectImage_"+this.state.projectId} src={tempProjectImageURL} />	
							</div>
			
		  }	
			
			
			console.log("Was ist das für ein Logo File")
			console.log(this.state.currentprojectlogoimage)
			
			if((this.state.currentprojectlogoimage !="") && (this.state.currentprojectlogoimage != undefined)) {
			
			

			var cHashp = Math.random().toString(16).substr(2, 8);	
			tempProjectLogoImageURL = "https://firebasestorage.googleapis.com/v0/b/moval-4c0b4.appspot.com/o/images%2F"+this.state.projectId+"%2F"+this.state.currentprojectlogoimage+"?alt=media&cHash="+cHashp;	
			
			projectLogoImage = <div className="image_wrapper">
												<img alt="Logo Image" className="previewprojectlogoimage" style={{ maxWidth: '300' }} id={"projectLogoImage_"+this.state.projectId} src={tempProjectLogoImageURL} />	
							</div>
		  }	
			
			
			
			
			
			var convertedArMarker = ""
			if((this.state.markerAR != undefined) && (this.state.markerAR != "")) {
			convertedArMarker =  this.state.markerAR.replace(/\\"/g, "\"").replace(/\\'/g, "\'");
				}

			
			var markerText = ""
			if((this.state.markerText != undefined) && (this.state.markerText != "")) {
			markerText =  this.state.markerText.replace(/\\"/g, "\"").replace(/\\'/g, "\'");
				}
			
						console.log("guggn"+this.state.viewModeMarker)

		
			return (
				<main className={classes.content}>
					<div className={classes.toolbar} />
				
				<Dialog fullScreen open={markerWindowOpen} onClose={handleCloseMarkerWindow} TransitionComponent={Transition}>
						<AppBar className="appBar">
							<Toolbar>
								<IconButton edge="start" color="inherit" onClick={handleCloseMarkerWindow} aria-label="close">
									<CloseIcon />
								</IconButton>
								
									
								
								
				
								{(((this.state.projectType == 0) || (this.state.projectType == 1)) && (this.state.viewModeMarker !="editMarker") ) && 
								<Typography variant="h6" className={classes.title}>
									{this.state.viewMode === 'Edit' ? 'Edit Project' : 'Create new visual marker'}
								</Typography>
								}

								{(((this.state.projectType == 0) || (this.state.projectType == 1)) && (this.state.viewModeMarker =="editMarker") ) && 
								<Typography variant="h6" className={classes.title}>
									{this.state.viewMode === 'Edit' ? 'Edit Project' : 'Edit visual marker'}
								</Typography>
								}

								


								{((this.state.projectType == 2) && (this.state.viewModeMarker !="editMarker"))  && 
								<Typography variant="h6" className={classes.title}>
									{this.state.viewMode === 'Edit' ? 'Edit Project' : 'Create new geo marker'}
								</Typography>
								}

									{((this.state.projectType == 2) && (this.state.viewModeMarker =="editMarker"))  && 
								<Typography variant="h6" className={classes.title}>
									{this.state.viewMode === 'Edit' ? 'Edit Project' : 'Edit geo marker'}
								</Typography>
								}



							</Toolbar>
						</AppBar>
						
						<form className={classes.form} noValidate>
							<Grid container spacing={2} className={classes.firstLine}>
								<Grid item xl={4} md={4} xs={12} className="forminput">
				
									<label className="formlabel">Marker Title*</label>
									<TextField
										variant="standard"
										required				
										placeholder="Marker title"
										id="markerTitle"
										label=""
										name="markerTitle"
										autoComplete="markerTitle"
										helperText={this.state.showMarkerTitleHelper && "Marker title is required"}
										value={this.state.markerTitle}
										error={this.state.showMarkerTitleHelper ? true : false}
										onChange={this.handleMarkerChange}
										disabled={this.state.viewModeMarker == 'editMarker' ? true : false }
									/>
								</Grid>
							</Grid>
							<Grid container spacing={2} className={classes.formcontent}>
								<Grid item xl={6} md={6} xs={12}>
									<label className="formlabel">Marker description</label>
									<TextField
										variant="standard"
										id="markerDescription"
										name="markerDescription"
										placeholder="Marker description"
										autoComplete="markerDescription"
										multiline
										rows={3}
										rowsMax={25}
										helperText={errors.body}
										error={errors.body ? true : false}
										onChange={this.handleMarkerChange}
										value={this.state.markerDescription}
									/>
								</Grid>
							</Grid>
							 <div className="breakerheadline"><h4>Type of marker</h4></div>

							   <Grid container spacing={2} className={classes.formcontent} xl={3} xs={12}>
										<Grid item l={3} sm={6} xs={12} >
				
													<label className="formlabel">Marker type*</label>

													<NativeSelect className="markerTypeInput"
													  value={this.state.markerType}
													  onChange={this.handleMarkerChange}
													  inputProps={{
														name: 'markerType',
														id: 'markerType',
													  }}
													>
													  <option aria-label="None" value="" />
														  <option value={1}>URL</option>
														  <option value={2}>Text</option>
														  <option value={3}>External Image</option>
														  <option value={4}>Video</option>
														  <option value={5}>Audio</option>
														  <option value={6}>External File</option>
														  <option value={7}>AR+</option>
													</NativeSelect>
										</Grid>
				
				
								<Grid item l={3} sm={6} xs={12} className="forminput" style={{ display: this.state.showMarkerURL ? "block" : "none" }} >
				
					<label className="formlabel" style={{ display: this.state.showMarkerURL ? "block" : "none" }}>Open inline</label>	
				
											 <FormControlLabel style={{ display: this.state.showMarkerURL ? "block" : "none" }} control={
												<Checkbox
													checked={this.state.markerURLInline}
													onChange={this.handleMarkerChange}
													id="markerURLInline"
													name="markerURLInline"
												  />}
												 label="Show page inline" />
														
												
										</Grid>

										<Grid item l={3} sm={6} xs={12} className="forminput" style={{ display: this.state.showExternalImageURL? "block" : "none" }}>
											
											
											<label className="formlabel" style={{ display: this.state.showExternalImageURL? "block" : "none" }}>Gallery view</label>		
																		
																	<FormControlLabel style={{ display: this.state.showExternalImageURL? "block" : "none" }} control={
																		<Checkbox
																			checked={this.state.galleryView}
																			onChange={this.handleMarkerChange}
																			id="galleryView"
																			name="galleryView"
																		  />}
																		 label="show as gallery view" />
											
											

										 </Grid>
				
				
										<Grid item l={3} sm={6} xs={12} className="forminput" style={{ display: this.state.showFileURL? "block" : "none" }}>
											
											
											<label className="formlabel" style={{ display: this.state.showFileURL? "block" : "none" }}>show inline (pdf only)</label>		
																		
																	<FormControlLabel style={{ display: this.state.showFileURL? "block" : "none" }} control={
																		<Checkbox
																			checked={this.state.pdfView}
																			onChange={this.handleMarkerChange}
																			id="pdfView"
																			name="pdfView"
																		  />}
																		 label="show inline (PDF only)" />
											
											

										 </Grid>
			
								</Grid>
				
				
				
				
				
		
								<Grid container spacing={2} className={classes.formcontent} xl={4} xs={12}>
										<Grid item l={6} sm={6} xs={12}>
											{this.state.showMarkerTypeHelper && (
												<div className="inputError">Please select a marker type</div>
												)}
										</Grid>
								</Grid>
				
												
		
								<Grid container spacing={2} className={classes.formcontent} xl={6} xs={12}>
										<Grid item l={6} sm={6} xs={12} className="forminput">
											<TextField
												style={{ display: this.state.showMarkerURL ? "block" : "none" }}
												variant="standard"
												required
												fullWidth
												id="markerURL"
												name="markerURL"
												placeholder="Website URL"
												autoComplete="markerURL"
												helperText={errors.body}
												error={errors.body ? true : false}
												onChange={this.handleMarkerChange}
												value={this.state.markerURL}
											/>
				
											<TextField
												style={{ display: this.state.showTextMarker ? "block" : "none" }}
												variant="standard"
												fullWidth
												multiline
												rows={8}
												rowsMax={16}
												id="markerText"
												name="markerText"
												placeholder="Text Marker"
												autoComplete="markerText"
												helperText={errors.body}
												error={errors.body ? true : false}
												onChange={this.handleMarkerChange}
												value={markerText}
											/>
				
				
				
											<TextField
												style={{ display: this.state.showExternalImageURL ? "block" : "none" }}
												variant="standard"
												fullWidth
												id="externalImageURL"
												placeholder="External Image URL"
												name="externalImageURL"
												autoComplete="externalImageURL"
												helperText={errors.body}
												error={errors.body ? true : false}
												onChange={this.handleMarkerChange}
												value={this.state.externalImageURL}
											/>
				
				
											<TextField
												style={{ display: this.state.showVideoURL ? "block" : "none" }}
												variant="standard"
												fullWidth
												id="videoURL"
												placeholder="Video URL"
												name="videoURL"
												placeholder="Video URL"
												autoComplete="videoURL"
												helperText={errors.body}
												error={errors.body ? true : false}
												onChange={this.handleMarkerChange}
												value={this.state.videoURL}
											/>
				
											<TextField
												style={{ display: this.state.showAudioURL ? "block" : "none" }}
												variant="standard"
												fullWidth
												id="audioURL"
												placeholder="Audio URL"
												name="audioURL"
												autoComplete="audioURL"
												helperText={errors.body}
												error={errors.body ? true : false}
												onChange={this.handleMarkerChange}
												value={this.state.audioURL}
											/>
											<p><i class="audioHint" style={{ display: this.state.showAudioURL ? "block" : "none" }}>comma seperate: 1st part audio URL, 2nd poster URL</i></p>
				
											<TextField
												style={{ display: this.state.showFileURL ? "block" : "none" }}
												variant="standard"
												id="fileURL"
												placeholder="File URL"
												name="fileURL"
												autoComplete="fileURL"
												helperText={errors.body}
												error={errors.body ? true : false}
												onChange={this.handleMarkerChange}
												value={this.state.fileURL}
											/>
													
												<TextField
												className="fileDescription"
												style={{ display: this.state.showFileURL ? "block" : "none" }}
												variant="standard"
												id="fileURLdescription"
												placeholder="File URL description"
												name="fileURLdescription"
												autoComplete="fileURLdescription"
												helperText={errors.body}
												error={errors.body ? true : false}
												onChange={this.handleMarkerChange}
												value={this.state.fileURLdescription}
											/>		
				
				
											<TextField
                                                style={{ display: this.state.showARMarker && String(this.state.markerType) !== "7" ? "block" : "none" }}
												variant="standard"
												fullWidth
												multiline
												rows={16}
												rowsMax={32}
												id="markerAR"
												placeholder="AR Content"
												name="markerAR"
												autoComplete="markerAR"
												helperText={errors.body}
												error={errors.body ? true : false}
												onChange={this.handleMarkerChange}
												value={convertedArMarker}
											/>
                                                    
                                            {String(this.state.markerType) === "7" && (
                                              <SceneEditor
                                                value={this.state.markerARtemp}
                                                onChange={(scene) => {
                                                  // ✅ Editor arbeitet mit Objekt
                                                  // ✅ markerAR wird der JSON String
                                                  this.setState({
                                                    markerARtemp: scene,
                                                    markerAR: JSON.stringify(scene),
                                                  });
                                                }}
                                              />
                                            )}


										</Grid>
										<Grid item l={6} sm={6} xs={12} className="forminput">

											<TextField
												style={{ display: this.state.showExternalImageURL ? "block" : "none" }}
												variant="standard"
												fullWidth
												id="externalImageURLLinks"
												placeholder="Links on images (incl. https://)"
												name="externalImageURLLinks"
												autoComplete="externalImageURLLinks"
												helperText={errors.body}
												error={errors.body ? true : false}
												onChange={this.handleMarkerChange}
												value={this.state.externalImageURLLinks}
											/>
										</Grid>			

										
				
									</Grid>
				
								 <div className="breakerheadline"><h4>Marker attributes</h4></div>

									  <Grid container spacing={2} className={classes.formcontent} l={12} xs={12}>
														
															<Grid item xl={3} sm={3} xs={12} className="forminput">
																
																<label className="formlabel">Marker style*</label>

															<NativeSelect
															  value={this.state.markerStyle}
															  onChange={this.handleMarkerChange}
															  inputProps={{
																name: 'markerStyle',
																id: 'markerStyle',
															  }}
															>
															  <option value="icon">Icon</option>
															  <option value="frame">Frame</option>
														  
															</NativeSelect>
																
															</Grid>

														  <Grid item xl={3} sm={3} xs={12} className="forminput">
																
																<label className="formlabel" style={{ display: this.state.showMarkerColor ? "block" : "none" }}>Marker Color</label>
																	
																	<TextField
																		style={{ display: this.state.showMarkerColor ? "block" : "none" }}
																		variant="standard"
																		required
																		fullWidth
																		id="markerColor"
																		name="markerColor"
																		placeholder="Marker color"
																		autoComplete="markerColor"
																		helperText={errors.body}
																		error={errors.body ? true : false}
																		onChange={this.handleMarkerChange}
																		value={this.state.markerColor}
																	/>
																	
																	
																	<label className="formlabel" style={{ display: this.state.showMarkerDirectOpen? "block" : "none" }}>Action on detection</label>		
																		
																	<FormControlLabel style={{ display: this.state.showMarkerDirectOpen? "block" : "none" }} control={
																		<Checkbox
																			checked={this.state.markerDirectOpen}
																			onChange={this.handleMarkerChange}
																			id="markerDirectOpen"
																			name="markerDirectOpen"
																		  />}
																		 label="auto open marker on detection" />
																			
																			

															</Grid>	
										</Grid>

 											<Grid container spacing={2} className={classes.formcontent} l={12} xs={12}>
														
															<Grid item xl={3} sm={3} xs={12} className="forminput">
																<label className="formlabel">Overlay style</label>

															<NativeSelect
															  value={this.state.overlayStyle}
															  onChange={this.handleMarkerChange}
															  inputProps={{
																name: 'overlayStyle',
																id: 'overlayStyle',
															  }}
															>
															  <option value="sheet">sheet</option>
															  <option value="overlay">overlay</option>
														  
															</NativeSelect>
															</Grid>	
											</Grid>
				
								<Grid container spacing={2} className={classes.formcontent} l={12} xs={12}>
														
									<Grid item xl={3} sm={3} xs={12} className="forminput">
										<label className="formlabel">Marker hidden</label>		
																	<FormControlLabel control={
																		<Checkbox
																			checked={this.state.markerHidden}
																			onChange={this.handleMarkerChange}
																			id="markerHidden"
																			name="markerHidden"
																		  />}
																		 label="marker hidden" />						
									 </Grid>

								</Grid>

								{this.state.projectType == 2 &&
								 <Grid container spacing={2} className="latLngBlock" l={12} xs={12}>
									 <Grid item xl={3} sm={3} xs={12} className="forminput">
									 	 <label className="formlabel">Latitude*</label>
								 
								 		<TextField
											required
											fullWidth
											id="geoLatitude"
											placeholder="Latitude"
											name="_latitude"
											autoComplete="geoLatitude"
											helperText={this.state.showGeoLatitudeHelper && "Latitude of marker"}
											error={this.state.showGeoLatitudeHelper ? true : false}
											value={this.state.geoPoint._latitude}
								 			onChange={this.handleMarkerChange}

											/>

									 </Grid> 
								 		<Grid item xl={3} sm={3} xs={12} className="forminput">
									 		 <label className="formlabel">Longitude*</label>
								 			<TextField
											required
											fullWidth
											id="geoLongitude"
											placeholder="Longitude"
											name="_longitude"
											autoComplete="geoLongitude"
											helperText={this.state.showGeoLongitudeHelper && "Longitude of marker"}
											error={this.state.showGeoLongitudeHelper ? true : false}
											value={this.state.geoPoint._longitude}
								 			onChange={this.handleMarkerChange}

											/>
									 </Grid> 
								 </Grid>
								}
				
								{this.state.projectType == 1 &&
							    <Grid container spacing={2} className={classes.formcontent} l={12} xs={12}>
														
															<Grid item xl={3} sm={3} xs={12} className="forminput">
				
																<label className="formlabel">Marker width*</label>

																<TextField
																	required
																	fullWidth
																	id="markerWidth"
																	placeholder="Marker Width in mm"
																	name="markerWidth"
																	autoComplete="markerWidth"
																	helperText={this.state.showMarkerWidthHelper && "Width in mm is needed for exact recognition"}
																	error={this.state.showMarkerWidthHelper ? true : false}
																	onChange={this.handleMarkerChange}
																	value={this.state.markerWidth}
																/>

															</Grid>

															<Grid item xl={3} sm={3} xs={12}>
				
																<label className="formlabel">Marker height*</label>

																<TextField
																	required
																	fullWidth
																	id="markerHeight"
																	placeholder="Marker Height in mm"
																	name="markerHeight"
																	autoComplete="markerHeight"
																	helperText={this.state.showMarkerHeightHelper && "Height in mm is needed for exact recognition"}
																	error={this.state.showMarkerHeightHelper ? true : false}
																	onChange={this.handleMarkerChange}
																	value={this.state.markerHeight}
																/>
															</Grid>
													
				
				
								</Grid>
								}
				
										 <Grid container spacing={2} className={classes.formcontent} l={12} xs={12}>
													

													<Grid item l={4} sm={4} xs={12}>
													<label className="formlabel">Marker image original*</label>
													{markerImage && (
														  <img alt="Crop" style={{ maxWidth: '100%' }} src={markerImageUrl} />
														)}
													</Grid>
													<Grid item l={4} sm={4} xs={12}>
													<label className="formlabel">Marker image cropped</label>
													{markerSrc && (
														  <ReactCrop
															src={markerSrc}
															crop={crop}
															ruleOfThirds
															onImageLoaded={this.onImageLoaded}
															onComplete={this.onCropComplete}
															onChange={this.onCropChange}
														  />
														)}
				
													</Grid>		
		
													
				
											</Grid>
											<Grid container spacing={2} className={classes.formcontent} l={12} xs={12}>

											<div className="imageinput">

														<input type="file" onChange={this.onSelectFile} />

														{this.state.imageError ? (
															<div className={classes.customError}>
																{' '}
																Wrong Images Format || Supported Format are PNG and JPG
															</div>
														) : (
															false
														)}
								
												</div>
												

										</Grid>

										<Grid container spacing={2} className={classes.formcontent} xl={4} xs={12}>
											
										{this.state.showMarkerImageHelper && (
												<div className="inputError errorImage">Something has to be recognized...</div>
												)}
										</Grid>

										<Grid container spacing={2} className={classes.formcontent} xl={4} xs={12}>
										<div className="markerIdBlock"><p>Marker-Id:{this.state.markerId}</p></div>
										</Grid>
										<div className="markersubmitarea">
											 <Grid container spacing={2}  l={12} xs={12}>

												<Button
												className ="save_button"
												autoFocus
												color="inherit"
												onClick={handleMarkerSubmit}
												className="save_button"
											>
												{this.state.buttonType === 'Edit' ? 'Save' : 'Add marker'}
											</Button>	 

											</Grid>
										</div>
										
										<div className={classes.progress} />

						
				
				
							
						</form>
					</Dialog>
				
					
					<Box className={classes.block}>
				
					<h2>{this.state.viewMode === 'editProject' ? 'Edit Project' : 'Project '+ this.state.projectTitle} </h2>
				
					
						<form autoComplete="off" noValidate>
						
							
									
									<Grid  item xl={8} sm={8} xs={12} >
											<TextField
												fullWidth
												margin="dense"
												name="projectTitle"
												value={this.state.projectTitle}
												onChange={this.handleChange}
												variant="standard"
												placeholder="Project title"
							


											/>
										</Grid>
											   
										
									<Grid xl={8} sm={8} xs={12}>
										<TextField
											fullWidth
											margin="dense"
											name="projectSubline"
											value={this.state.projectSubline}
											onChange={this.handleChange}
											placeholder="Subline"
											variant="standard"
										/>
									</Grid>

									<Grid  xl={8} sm={8} xs={12}>
										<TextField
											fullWidth
											  multiline
											  rows={2}
											  rowsMax={4}
											margin="dense"
											name="projectDescription"
											value={this.state.projectDescription}
											onChange={this.handleChange}
											placeholder="Description"
										/>
									</Grid>
											   
										
								<Grid xl={3} sm={8} xs={12} >
									<TextField
											fullWidth
											margin="dense"
											name="projectCode"
											value={this.state.projectCode}
											onChange={this.handleChange}
											variant="standard"
											placeholder="#Code"

										/>
									</Grid>

									<Grid xl={8} sm={8} xs={12} >
									<TextField
											fullWidth
											margin="dense"
											name="projectColor"
											value={this.state.projectColor}
											onChange={this.handleChange}
											variant="standard"
											placeholder="color in hex"

										/>
									</Grid>
									<Grid xl={8} sm={8} xs={12} >
									<TextField
											fullWidth
											margin="dense"
											name="projectDataLink"
											value={this.state.projectDataLink}
											onChange={this.handleChange}
											variant="standard"
											placeholder="External data link"

										/>
									</Grid>

<Grid xs={12} sm={8} md={6} lg={4} xl={4}>
 <FormControl fullWidth margin="dense"   style={{ marginBottom: 24 }}>
  <InputLabel id="project-categories-label">Kategorien</InputLabel>

  <Select
    labelId="project-categories-label"
    id="project-categories"
    multiple
    value={this.state.projectCategories}
    onChange={this.handleCategoryChange}
     style={{
        backgroundColor: this.state.projectCategories.length > 0 ? "#f4f4f4" : "white"
      }}
    renderValue={(selected) => (
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {selected.map((value) => {
          const cat = this.state.availableCategories.find(
            (c) => c.categoryId === value   // WICHTIG: categoryId
          );
          return (
            <Chip
              key={value}
              label={cat ? cat.categoryTitle : value}
              style={{ marginRight: 4, marginBottom: 4 }}
            />
          );
        })}
      </div>
    )}
  >
    {this.state.availableCategories.map((cat) => (
      <MenuItem key={cat.categoryId} value={cat.categoryId}>
        {cat.categoryTitle}
      </MenuItem>
    ))}
  </Select>
</FormControl>
</Grid>



								   <Grid container xl={8} sm={8} xs={12}>
											<Grid item xl={6} sm={6} xs={12}>
												
												<FormControlLabel control={
												<Checkbox
													checked={this.state.projectActive}
													onChange={this.handleChange}
													id="projectActive"
													name="projectActive"
													/>}
												 label="is actives" />
											</Grid>	

											<Grid item xl={6} sm={6} xs={12}>
												<FormControlLabel control={
												<Checkbox
													checked={this.state.projectPrivate}
													onChange={this.handleChange}
													id="projectPrivate"
													name="projectPrivate"
													/>}
												 label="is private" />
											</Grid>	

											<Grid item xl={6} sm={6} xs={12}>
												<FormControlLabel control={
											<Checkbox
												checked={this.state.projectExclusive}
												onChange={this.handleChange}
												id="projectExclusive"
												name="projectExclusive"
												/>}
											 label="is exclusive" />
											</Grid>	
											
											<Grid item xl={6} sm={6} xs={12}>
												<FormControlLabel control={
											<Checkbox
												checked={this.state.projectHideMarkerlist}
												onChange={this.handleChange}
												id="projectHideMarkerlist"
												name="projectHideMarkerlist"
												/>}
											 label="hide marker list" />	
											</Grid>		
										
									</Grid>	


								
									<Grid className="imageMarkerBlock" container xl={8} sm={8} xs={12}>
										
									{this.state.projectId != '' && 
									<Grid item md={6} xs={12}>		
								
										<div className="visual_marker_block">
											<h3>Project image</h3>
									 		{projectImage}
											<p>Add a new image to your project</p>
											<p>
											<i className="imageHint">recommended size: 1125px/1350px (W/H)</i>
											</p>
										</div>	

										<div>
										{this.state.projectImageRdy != 0 &&
										<Button
										 	variant="contained"
									
											className="add_profileimagebutton"
											type="submit"
											size="small"
											startIcon={<CloudUploadIcon />}
											onClick={this.projectPictureHandler}
										>
											Upload Photo
										</Button>
									}
										<input type="file" onChange={this.handleImageChange} 											className="add_profileimageinput"
/>

										{this.state.imageError ? (
											<div className={classes.customError}>
												{' '}
												Wrong Image Format || Supported Format are PNG and JPG
											</div>
										) : (
											false
									)}
								</div>

									
								</Grid>
								}
								
								
								{this.state.projectId != '' &&
									<Grid className="logoMarkerBlock" item md={6} xs={12}>		

										<div className="visual_marker_block">
											<h3 >Logo image</h3>
									 
									 
									 		{projectLogoImage}
									 
									 
											<p>Add a new logo image to your project</p>
									
										</div>	

										<div>
										{this.state.projectLogoImageRdy != 0 &&
										<Button
										 	variant="contained"
									
											className="add_profileimagebutton"
											type="submit"
											size="small"
											startIcon={<CloudUploadIcon />}
											onClick={this.projectLogoPictureHandler}
										>
											Upload Photo
										</Button>
									}
										<input type="file" onChange={this.handleLogoImageChange} 											className="add_profileimageinput"
/>

										{this.state.imageError ? (
											<div className={classes.customError}>
												{' '}
												Wrong Image Format || Supported Format are PNG and JPG
											</div>
										) : (
											false
									)}
								</div>

									
								</Grid>
							}
								
								</Grid>	
								
								
								
								
								
								
								<Grid item md={6} xs={12} className="projectTypeBlock">	

											<h3 >Project Type</h3>
											<NativeSelect className="projectType"
													  value={this.state.projectType}
													  onChange={this.handleProjectTypeChange}
													  inputProps={{
														name: 'projectType',
														id: 'projectType',
													  }}
													>
													<option value={0}>--- select type ---</option>
													<option value={1}>visual</option>
													<option value={2}>Geo</option>
											</NativeSelect>
								</Grid>
								
{this.state.projectId && (
  <Grid item xs={12} sm={8} md={6} lg={4} xl={4} style={{ marginTop: 24 }}>
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6">WebAR Download / Link</Typography>

        <Box mt={2} display="flex" justifyContent="center">
          <QRCodeCanvas
  id={`project-qr-${this.state.projectId}`}
  value={`https://webar.moval.io/v10/${this.state.projectCode}`}
  size={180}
  includeMargin
/>
        </Box>

        <Box mt={2}>
  <TextField
    fullWidth
    variant="standard"
    value={`https://webar.moval.io/v10/${this.state.projectCode}`}
    InputProps={{ readOnly: true }}
  />
</Box>

<Box mt={2} display="flex" gridGap={8} flexWrap="wrap">
  

  <Button
    variant="outlined"
variant="contained"
    className="copylinkButton"
    color="primary"
    onClick={() =>
      navigator.clipboard &&
      navigator.clipboard.writeText(
        `https://webar.moval.io/v10/${this.state.projectCode}`
      )
    }
  >
    Link kopieren
  </Button>

  <Button
  variant="contained"
    color="primary"
    className="qrdownloadButton"
  onClick={() => {
    const canvas = document.getElementById(
      `project-qr-${this.state.projectId}`
    );
    if (!canvas) return;

    const scale = 4; // 🔥 4x Auflösung (720x720 bei size=180)

    const exportCanvas = document.createElement('canvas');
    exportCanvas.width = canvas.width * scale;
    exportCanvas.height = canvas.height * scale;

    const ctx = exportCanvas.getContext('2d');
    ctx.scale(scale, scale);
    ctx.drawImage(canvas, 0, 0);

    const pngUrl = exportCanvas.toDataURL('image/png');

    const a = document.createElement('a');
    a.href = pngUrl;
    a.download = `webar-${this.state.projectId}.png`;
    a.click();
  }}
>
  QR downloaden (HD)
</Button>
</Box>
      </CardContent>
    </Card>
  </Grid>
)}

							
							<Grid item md={6} xs={12}>		
								
								{this.state.projectId != '' && (this.state.projectType == 0 || this.state.projectType == 1) &&
										<div className="visual_marker_block">
											<h3 >Visual Marker</h3>
											<p>Add one or more visual marker to project.</p>
										</div>	
								  }
								</Grid>
										
								
									<Grid item md={6} xs={12}>
									
									{this.state.projectId != '' && (this.state.projectType == 0 || this.state.projectType == 1) &&
										<div className="visual_marker_addblock">
									 
										 <Button
											variant="contained"
											color="default"
											className="add_button"
											onClick={() => this.handleAddMarkerOpenWindow()}
											startIcon={	<FontAwesomeIcon icon={faPlusSquare} size="xs"/>}
										  >
											Add marker
										  </Button>
										</div>
									 }
	
									</Grid>			
						
								
								<Grid
								  container
								  direction="row"
								  justifyContent="flex-start"
								  alignItems="flex-start"
 								  spacing={1}
								>	
	  
												
								{ this.state.visualMarker != undefined && (this.state.projectType == 0 || this.state.projectType == 1) &&
									  this.state.visualMarker.map(function(marker) {	
								 
								 var markerIcon = ""
								 
								 if(marker.markerType == "1"){
								 
								 markerIcon = 
									 			<div className="markerIcon">
													<FontAwesomeIcon icon={faGlobe} size="lg"/>
												</div>
								  
								 }
								 
								  if(marker.markerType == "2"){
								 
								 markerIcon = 
									 			<div className="markerIcon">
													<FontAwesomeIcon icon={faAlignLeft} size="lg"/>
												</div>
								  
								 }

	  							if(marker.markerType == "3"){
								 
								 markerIcon = 
									 			<div className="markerIcon">
													<FontAwesomeIcon icon={faImage} size="lg"/>
												</div>
								  
								 }


								if(marker.markerType == "4"){
								 
								 markerIcon = 
									 			<div className="markerIcon">
													<FontAwesomeIcon icon={faVideo} size="lg"/>
												</div>
								  
								 }


								if(marker.markerType == "5"){
								 
								 markerIcon = 
									 			<div className="markerIcon">
													<FontAwesomeIcon icon={faVolumeUp} size="lg"/>
												</div>
								  
								 }
									
								if(marker.markerType == "6"){
								 
								 markerIcon = 
									 			<div className="markerIcon">
													<FontAwesomeIcon icon={faFile} size="lg"/>
												</div>
								  
								 }
									
									if(marker.markerType == "7"){
								 
								 markerIcon = 
									 			<div className="markerIcon">
													<FontAwesomeIcon icon={faEye} size="lg"/>
												</div>
								  
								 }

									
							
								 // new added marker = blob / existing marker URL String
								 if(marker.markerImage instanceof Blob){
								 
							

								 
								 var tempMarkerImageURL= URL.createObjectURL(marker.markerImage);
								 console.log("Es handelt sich um eine Blob URL ")

								 console.log(tempMarkerImageURL)
								 }
								 
								else{
									
								 console.log("Es handelt sich um eine ganz normale URL ")
								 console.log(marker.markerImage)

								 var tempMarkerImageURL= marker.markerImage;
								
									if(tempMarkerImageURL.includes('https')){
										
										
									}
									// new added marker after saving project ( https:// url not generated yet)
									else{
										console.log("HTTPS NOT INCLUDED")
										console.log(marker)
									var projectName = marker.projectId;
									
										//cHash for Update of image
									var cHash = Math.random().toString(16).substr(2, 8);	
									tempMarkerImageURL = "https://firebasestorage.googleapis.com/v0/b/moval-4c0b4.appspot.com/o/images%2F"+projectName+"%2F"+marker.markerImage+"?alt=media&cHash="+cHash;	
									}
									
								}
							
								 return(
								  <Grid item xs={12} sm={10} md ={4} lg={3}  className="visual_marker_list">
									  <Card className={classes.root} variant="outlined" onClick={() => handleEditMarkerOpenWindow(marker)}>
										<CardContent>
									 		<div className="image_wrapper">
												<img alt="Crop"className="markerimage" style={{ maxWidth: '300', width:'100%' }} id={"markerImage_"+marker.markerId} src={tempMarkerImageURL} />
									 
									 			{markerIcon}
									 			
									 		</div>
									 		<div className="text_wrapper">
												<Typography variant="h5" component="h4">
												{marker.markerTitle}
												</Typography>
											<p>{marker.markerDescription}</p>
											<Button
												className="edit_button"												
												onClick={() => handleEditMarkerOpenWindow(marker)}
												startIcon={	<FontAwesomeIcon icon={faEdit} size="xs"/>}
											  >
												edit
											  </Button>

											<Button
											    className="delete_button"
												onClick={() => handleDeleteMarker(marker)}
												startIcon={		<FontAwesomeIcon icon={faTrash} size="xs"/>}
											  >
												delete
											  </Button>	
											</div>	
															 
										</CardContent>
									</Card>
										
								</Grid>	
								 )
								 
								})}
				
								</Grid>
								<Divider />
									
									
								<Grid item md={6} xs={12}>		
								
								{this.state.projectId != '' && this.state.projectType == 2 &&
										<div className="geo_marker_block">
											<h3 >Geo marker</h3>
											<p>Add one or more geo marker to project.</p>
										</div>	
								  }
								</Grid>
										
								
								<Grid item md={6} xs={12}>
									
									{this.state.projectId != ''  && this.state.projectType == 2 &&
										<div className="geo_marker_addblock">
									 
										 <Button
											variant="contained"
											color="default"
											className="add_button"
											onClick={() => this.handleAddGeoMarkerOpenWindow()}
											startIcon={	<FontAwesomeIcon icon={faPlusSquare} size="xs"/>}
										  >
											Add Geo Marker
										  </Button>
										</div>
									 }
	
									</Grid>	


								<Grid
								  container
								  direction="row"
								  justifyContent="flex-start"
								  alignItems="flex-start"
 								  spacing={1}
								>	
	  
												
								{ this.state.geoMarker != undefined && this.state.projectType == 2  &&
									  this.state.geoMarker.map(function(marker) {	
								 
								 var markerIcon = ""
								 
								 if(marker.markerType == "1"){
								 
								 markerIcon = 
									 			<div className="markerIcon">
													<FontAwesomeIcon icon={faGlobe} size="lg"/>
												</div>
								  
								 }
								 
								 // new added marker = blob / existing marker URL String
								 if(marker.markerImage instanceof Blob){
								 
							

								 
								 var tempMarkerImageURL= URL.createObjectURL(marker.markerImage);
								 console.log("Es handelt sich um eine Blob URL ")

								 console.log(tempMarkerImageURL)
								 }
								 
								else{
									
								

								 var tempMarkerImageURL= marker.markerImage;
								
									if(tempMarkerImageURL.includes('https')){
										
										
									}
									// new added marker after saving project ( https:// url not generated yet)
									else{

									var projectName = marker.projectId;
									
										//cHash for Update of image
									var cHash = Math.random().toString(16).substr(2, 8);	
									tempMarkerImageURL = "https://firebasestorage.googleapis.com/v0/b/moval-4c0b4.appspot.com/o/images%2F"+projectName+"%2F"+marker.markerImage+"?alt=media&cHash="+cHash;	
									}
									
								}
							
								 return(
								  <Grid item xs={12} sm={10} md ={4} lg={3}  className="geo_marker_list">
									  <Card className={classes.root} variant="outlined" onClick={() => handleEditGeoMarkerOpenWindow(marker)}>
										<CardContent>
									 		<div className="image_wrapper">
												<img alt="Crop" className="markerimage" style={{ maxWidth: '300', width:'100%' }} id={"markerImage_"+marker.markerId} src={tempMarkerImageURL} />
									 
									 			{markerIcon}
									 			
									 		</div>
									 		<div className="text_wrapper">
												<Typography variant="h5" component="h4">
												{marker.markerTitle}
												</Typography>
											<p>{marker.markerDescription}</p>
											<Button
												className="edit_button"												
												onClick={() => handleEditGeoMarkerOpenWindow(marker)}
												startIcon={	<FontAwesomeIcon icon={faEdit} size="xs"/>}
											  >
												edit
											  </Button>

											<Button
											    className="delete_button"
												onClick={() => handleDeleteMarker(marker)}
												startIcon={		<FontAwesomeIcon icon={faTrash} size="xs"/>}
											  >
												delete
											  </Button>	
											</div>	
															 
										</CardContent>
									</Card>
										
								</Grid>	
								 )
								 
								})}
				
								</Grid>
	
							<Divider />
							<CardActions />
											
					
						</form>
				</Box>
					<Button
						color="primary"
						variant="contained"
						type="submit"
						className="save_button"
						onClick={handleSubmit}
						disabled={
							this.state.buttonLoading ||
							!this.state.firstName ||
							!this.state.lastName ||
							!this.state.country
						}
					>
						Save project
						{this.state.buttonLoading && <CircularProgress size={30} className={classes.progess} />}
					</Button>
				</main>
			);
						 
			}//forced reaload			 				 
		}
	}
}


	
			
export default withStyles(styles)(newProject);